{
  "pages": [
    {
      "urlPath": "/",
      "title": "Hva er \ninnafor?",
      "subtitle": null,
      "ingress1": "Her kan du lære om sex og sunne grenser, og hva som er utafor.",
      "choices": [
        {
          "id": 1,
          "title": "LÆR MER",
          "ingress": "Trykk her for å utforske temaer som porno, onani, pedofili og mye mer!",
          "navigateTo": "/temavalg"
        },
        {
          "id": 2,
          "title": "Gjør du noe som er utafor?",
          "ingress": "Er du bekymret for om dine seksuelle tanker eller atferd er utafor? Sjekk det ut her!",
          "navigateTo": "/quizinngang"
        },
        {
          "id": 3,
          "title": "'Hva er innafor?' er et informasjon- og veiledningsverktøy. Verktøyet er laget av Helsedirektoratet i samarbeid med Bufdir og er 100% anonymt. ",
          "ingress": "Les mer om verktøyet, anonymitet og personvern ",
          "text": "her.",
          "navigateTo": "/om-verktoyet"
        }
      ],
      "navigationButtons": []
    },
    {
      "urlPath": "/om-verktoyet",
      "title": "Om verktøyet",
      "subtitle": "Anyonymitet og personvern",
      "ingress1": "'Hva er innafor?' er et informasjon- og veiledningsverktøy for å styrke ungdommers sunne seksuelle atferd og forebygge problematisk eller skadelig seksuell adferd. Den anbefalte aldersgruppen er ungdom i alderen 13-19 år. Dette er et digitalt lavterskeltilbud for ungdom, og ikke en erstatning for profesjonell helsehjelp. \n\n Veiledningsverktøyet er todelt. I den ene delen kan man lære mer om ulike temaer innen seksuell adferd (“Lær mer”). I den andre delen kan man ta en anonym test og få innsikt i et utvalg av situasjoner innenfor problematisk seksuell atferd (“Gjør du noe som er utafor?”). \n\n Veiledningsverktøyet er ment å skape bevisstgjøring og selvinnsikt, tilby forslag/øvelser til selvregulering og synliggjøre veier til ytterligere hjelp. Løsningen fokuserer på sunn seksualitet. Den skal være inkluderende og ikke dømmende. \n\n Deler av løsningen er utformet som en anonym quiz med spørsmål og svaralternativer som leder brukeren til en oppsummering med veiledning og lenker til artikler, videoer, chattetjenester og hjelp som er kvalitetssikret av Helsedirektoratet. \n\n Man kan utforske ulike svaralternativer uten at dataene brukes til å identifisere eller profilere brukeren. \n\n 'Hva er innafor?' er utviklet av Helsedirektoratet i samarbeid med fagfolk, V27, Betanien sykehus og avdelingen Ung.no i Bufdir. \n Den tekniske løsningen er laget av Norsk Helsenett på Helsenorge.no. \n Verktøyet er blant annet basert på spørsmål og innhold fra Ung.no.",
      "ingress2": "Løsningen sikrer anonymitet. Det er ingen innlogging eller fritekstfelt hvor man kan oppgi opplysninger om seg selv. Vi viser en oppsummering etter fullført quiz som er automatisk generert. Oppsummeringen genereres basert på de svaralternativene man velger. \n\n Vi benytter Adobe Analytics til å lage en anonymisert besøksstatistikk. Det samles ikke inn IP-adresser eller andre identifiserbare data som kan knyttes til enkeltpersoner — direkte eller indirekte. Besøksstatistikken bruker vi til å forbedre verktøyet.",
      "choices": null,
      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": "/" }]
    },
    {
      "urlPath": "/hva-beskriver-deg-best",
      "title": "Hva beskriver deg best?",
      "subtitle": null,
      "analyticsId": "kjønn",
      "choices": [
        {
          "id": 1,
          "text": "Jente",
          "navigateTo": "/hvor-gammel-er-du"
        },
        {
          "id": 2,
          "text": "Gutt",
          "navigateTo": "/hvor-gammel-er-du"
        },
        {
          "id": 1,
          "text": "Ikke-binær",
          "navigateTo": "/hvor-gammel-er-du"
        },
        {
          "id": 2,
          "text": "Vil ikke svare",
          "navigateTo": "/hvor-gammel-er-du"
        }
      ]
    },
    {
      "urlPath": "/hvor-gammel-er-du",
      "title": "Hvor gammel er du?",
      "subtitle": null,
      "analyticsId": "alder",
      "choices": [
        {
          "id": 1,
          "text": "Yngre enn 13",
          "navigateTo": "/for-ung"
        },
        {
          "id": 2,
          "text": "13 - 15",
          "navigateTo": "/temavalg",
          "responseType": 4
        },
        {
          "id": 3,
          "text": "16 - 18",
          "navigateTo": "/temavalg",
          "responseType": 4
        },
        {
          "id": 4,
          "text": "19 eller eldre",
          "navigateTo": "/for-gammel"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/hva-beskriver-deg-best"
        }
      ]
    },
    {
      "urlPath": "/for-ung",
      "title": "Beklager, du er dessverre yngre enn vår aldersgrense..",
      "subtitle": null,
      "ingress1": "Kom gjerne tilbake senere!",
      "choices": null,
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/hvor-gammel-er-du"
        }
      ]
    },
    {
      "urlPath": "/for-gammel",
      "title": "Dette verktøyet er ment for de mellom 13 og 19 år.",
      "subtitle": null,
      "ingress1": "Du er velkommen til å gå videre om du vil! Verktøyet gir god informasjon om seksuelle grenser og seksualitet som kan være nyttig uansett alder. Dersom du er ute etter spesifikk hjelp for personer over 18 år som har seksuell interesse for barn, så anbefaler vi at du i tillegg sjekker ut denne siden: <a href=\"https://detfinneshjelp.no\" target=\"_blank\">Detfinneshjelp.no</a>",
      "choices": null,
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/hvor-gammel-er-du"
        },
        { "text": "Gå videre", "type": 1, "navigateTo": "/temavalg" }
      ]
    },
    {
      "urlPath": "/temavalg",
      "title": "Velg et tema du vil vite mer om",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "icon": "Samtykke",
          "text": "Samtykke",
          "navigateTo": "/temavalg/samtykke"
        },
        {
          "id": 2,
          "icon": "Seksuell_lavalder",
          "text": "Seksuell lavalder",
          "navigateTo": "/temavalg/seksuell_lavalder"
        },
        {
          "id": 3,
          "icon": "Bilder_og_video",
          "text": "Bilder og video",
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        {
          "id": 4,
          "icon": "Mine_og_andres_grenser",
          "text": "Mine og andres grenser",
          "navigateTo": "/temavalg/mine_og_andres_grenser"
        },
        {
          "id": 5,
          "icon": "Tanker_og_fantasier",
          "text": "Tanker og fantasier",
          "navigateTo": "/temavalg/tanker_og_fantasier"
        },
        {
          "id": 6,
          "icon": "Onanering",
          "text": "Onanering",
          "navigateTo": "/temavalg/onanering"
        },
        {
          "id": 7,
          "icon": "Pedofili",
          "text": "Pedofili",
          "navigateTo": "/temavalg/pedofili"
        },
        {
          "id": 8,
          "icon": "Porno_og_gaming",
          "text": "Porno",
          "navigateTo": "/temavalg/porno_og_gaming"
        }
      ]
    },
    {
      "urlPath": "/temavalg/onanering",
      "title": "Onanering",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "text": "Onanerer jeg for mye?",
          "navigateTo": "/temabeskrivelse/onanerer_jeg_for_mye"
        },
        {
          "id": 2,
          "text": "Jeg blir ikke kåt",
          "navigateTo": "/temabeskrivelse/Jeg_blir_ikke_kat"
        },
        {
          "id": 3,
          "text": "Hvorfor får jeg vondt når jeg onanerer?",
          "navigateTo": "/temabeskrivelse/hvorfor_far_jeg_vondt_nar_jeg_onanerer"
        },
        {
          "id": 4,
          "text": "Kulturen eller religionen min advarer meg mot å onanere. Hva skal jeg gjøre?",
          "navigateTo": "/temabeskrivelse/kulturen_eller_religionen_min_advarer_meg_mot_a_onanere_hva_skal_jeg_gjore"
        },
        {
          "id": 5,
          "text": "Hvor kan jeg onanere?",
          "navigateTo": "/temabeskrivelse/hvor_kan_jeg_onanere"
        },
        {
          "id": 6,
          "text": "Er det ok for jenter å onanere?",
          "navigateTo": "/temabeskrivelse/er_det_ok_for_jenter_a_onanere"
        },
        {
          "id": 7,
          "text": "Blir jeg kåt på feil ting?",
          "navigateTo": "/temabeskrivelse/blir_jeg_kat_pa_feil_ting"
        },
        {
          "id": 8,
          "text": "Hva kan jeg gjøre hvis jeg vil slutte å bli kåt på noe?",
          "navigateTo": "/temabeskrivelse/hva_kan_jeg_gjore_hvis_jeg_vil_slutte_a_bli_kat_pa_noe"
        },
        {
          "id": 9,
          "text": "Er det lov å tenke på barn mens jeg onanerer?",
          "navigateTo": "/temabeskrivelse/er_det_lov_a_tenke_pa_barn_mens_jeg_onanerer"
        }
      ],
      "resources": [
        {
          "title": "Porno og sex, omtrent det samme?",
          "text": "Noen tenker at porno er det samme som sex, bare at det er filmet og lagt ut på nett, men det er noen viktige forskjeller.",
          "navigateTo": "https://www.ung.no/Sex/4273_Porno,_ikke_bare_greit.html"
        },
        {
          "title": "Kan man onanere for mye?",
          "text": "Onanering er helt vanlig og til og med sunt. Men alt som er sunt og vanlig kan også bli for mye. Selv om du ikke får fysiske skader, kan onanering bli problematisk hvis det blir veldig mye av det og det tar for stor plass i livet ditt.",
          "navigateTo": "https://www.youtube.com/watch?v=YbIjTVVDlNo"
        },
        {
          "title": "Hvorfor føles det ekkelt å bli tatt på?",
          "text": "Noen elsker å bli tatt på. Andre hater det. Det kan være vanskelig å forstå hvordan noe kan kjennes så forskjellig fra person til person.",
          "navigateTo": "https://www.ung.no/hvorfor-foles-det-ekkelt-a-bli-tatt-pa"
        },
        {
          "title": "Kan det være feil å onanere?",
          "text": "Onanerer du mye til porno, så mye at du ikke får nok tid til å gjøre andre ting? Eller onanerer du på en måte som andre reagerer negativt på?",
          "navigateTo": "https://www.ung.no/kan-det-vaere-feil-a-onanere"
        },
        {
          "title": "Alt om onanering",
          "text": "Å onanere er viktig for å bli kjent med egen nytelse, men det kan også hjelpe partneren din til orgasme. Her er noen gode tips.",
          "navigateTo": "https://www.ung.no/Sex/3211_Alt_om_onanering.html"
        },
        {
          "title": "Er du nysgjerrig på sex?",
          "text": "Det er vanlig å være nysgjerrig på sex. Noen får lyst til å utforske egen kropp mer, mens andre får lyst til å se på og ta på andre. Nysgjerrigheten gjør også at mange ser på porno.",
          "navigateTo": "https://www.ung.no/Sex/4611_Er_du_nysgjerrig_p%C3%A5_sex.html"
        },
        {
          "title": "Hva gjør at du blir kåt?",
          "text": "Hva som gjør oss kåte varierer fra person til person. De fleste har et eller annet som tenner dem litt ekstra seksuelt. Noen blir sjelden kåte, mens andre blir det ofte.",
          "navigateTo": "https://www.ung.no/Sex/4035_Hva_gj%C3%B8r_at_du_blir_k%C3%A5t.html"
        },
        {
          "title": "Stor eller liten sexlyst?",
          "text": "Hos de fleste varierer lysten på sex i perioder av livet. Men noen har mye lyst nesten hele tiden, andre har sjeldnere lyst, og noen har ikke sexlyst i det hele tatt.",
          "navigateTo": "https://www.ung.no/Sex/3902_Derfor_varierer_sexlysten_din.html"
        },
        {
          "title": "Hva er en fetisj?",
          "text": "Å tenne seksuelt på kroppsdeler eller ting som i utgangspunktet ikke regnes som seksuelle, kalles for en fetisj. Det er ikke uvanlig å ha en fetisj, men hva vi tenner på kan variere veldig fra person til person.",
          "navigateTo": "https://www.ung.no/Sex/3896_Hva_er_en_fetisj.html"
        },
        {
          "title": "Tips for å endre uvaner eller slutte med noe",
          "text": "Ønsker du å slutte med noe, starte med noe eller forandre på noe? Vi gir deg råd for en varig endring, så det ikke bare blir med tanken.",
          "navigateTo": "https://www.ung.no/psykisk/4213_Tips_for_%C3%A5_endre_uvaner_eller_slutte_med_noe.html"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": "/temavalg" }]
    },
    {
      "urlPath": "/temavalg/mine_og_andres_grenser",
      "title": "Mine og andres grenser",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "text": "Hvordan vet jeg om jeg har tråkket over andres grenser?",
          "navigateTo": "/temabeskrivelse/hvordan_vet_jeg_om_jeg_har_trakket_over_andres_grenser"
        },
        {
          "id": 2,
          "text": "Hvordan vet jeg om noen har tråkket over grensene mine?",
          "navigateTo": "/temabeskrivelse/hvordan_vet_jeg_om_noen_har_trakket_over_grensene_mine"
        },
        {
          "id": 3,
          "text": "Hvordan respektere andres grenser?",
          "navigateTo": "/temabeskrivelse/hvordan_respektere_andres_grenser"
        },
        {
          "id": 4,
          "text": "Hva skjer med meg hvis jeg har gjort noe seksuelt uten at den andre samtykket?",
          "navigateTo": "/temabeskrivelse/hva_skjer_med_meg_hvis_jeg_har_gjort_noe_seksuelt_uten_at_den_andre_samtykket"
        }
      ],
      "resources": [
        {
          "title": "Hva skjer i hjernen under sex?",
          "text": "Når vi har eller tenker på sex utløses hormonene dopamin og oxytocin i hjernen. Disse hormonene påvirker følelsene våre og kalles ofte for lykkehormonet og kjærlighetshormonet.",
          "navigateTo": "https://www.youtube.com/watch?v=jtkAA-AHFyI&list=PLS9Dbtm5qG5WEs45MOrRM90A-hXHF5_n3&index=2"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": "/temavalg" }]
    },
    {
      "urlPath": "/temavalg/tanker_og_fantasier",
      "title": "Tanker og fantasier",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "text": "Jeg blir kåt av noe veldig rart. Hva er normalt?",
          "navigateTo": "/temabeskrivelse/jeg_blir_kat_av_noe_veldig_rart_hva_er_normalt"
        },
        {
          "id": 2,
          "text": "Finnes det ulovlige fantasier?",
          "navigateTo": "/temabeskrivelse/finnes_det_ulovlige_fantasier"
        },
        {
          "id": 3,
          "text": "Hva er forskjellen på tanker og handling?",
          "navigateTo": "/temabeskrivelse/hva_er_forskjellen_pa_tanker_og_handling"
        },
        {
          "id": 4,
          "text": "Kulturen eller religionen min sier at det er feil å være kåt eller tenke på sex. Hva kan jeg gjøre?",
          "navigateTo": "/temabeskrivelse/kulturen_eller_religionen_min_sier_at_det_er_feil_a_vere_kat_eller_tenke_pa_sex_hva_kan_jeg_gjore"
        },
        {
          "id": 5,
          "text": "Hva om jeg fantaserer om familiemedlemmer?",
          "navigateTo": "/temabeskrivelse/hva_om_jeg_fantaserer_om_familiemedlemmer"
        },
        {
          "id": 6,
          "text": "Hva om jeg fantaserer om dyr?",
          "navigateTo": "/temabeskrivelse/hva_om_jeg_fantaserer_om_dyr"
        },
        {
          "id": 7,
          "text": "Hvordan kan jeg bli kvitt ubehagelige fantasier?",
          "navigateTo": "/temabeskrivelse/hvordan_kan_jeg_bli_kvitt_ubehagelige_fantasier"
        },
        {
          "id": 8,
          "text": "Hva er blotting?",
          "navigateTo": "/temabeskrivelse/hva_er_blotting"
        },
        {
          "id": 9,
          "text": "Kan jeg kikke på noen som gjør noe privat uten at de vet det?",
          "navigateTo": "/temabeskrivelse/kan_jeg_kikke_pa_noen_som_gjor_noe_privat_uten_at_de_vet_det"
        },
        {
          "id": 10,
          "text": "Har jeg lov til å ta andres undertøy?",
          "navigateTo": "/temabeskrivelse/har_jeg_lov_til_a_ta_andres_undertoy"
        }
      ],
      "resources": [
        {
          "title": "Har du rare sextanker?",
          "text": "Det å få bilder i hodet når du onanerer eller mens du har sex, er normalt. Men noen sextanker kan være uheldige for deg. Og det er en del seksuelle ting som kan skade deg selv eller andre.",
          "navigateTo": "https://www.ung.no/har-du-rare-sextanker"
        },
        {
          "title": "Er det lov å sende nudes eller dickpics?",
          "text": "Det kan være spennende å sende slike bilder, men i mange tilfeller kan det være straffbart. Her er det du trenger å vite om deling av nakenbilder.",
          "navigateTo": "https://www.ung.no/nettvett/4272_Er_det_lov_%C3%A5_sende_nudes_eller_dickpics.html"
        },
        {
          "title": "Hva er seksuelle overgrep?",
          "text": "Å gjøre noe seksuelt med noen som ikke vil det, kan være et seksuelt overgrep. Seksuelle overgrep og krenkelser er ulovlig.",
          "navigateTo": "https://www.ung.no/overgrep/2311_Hva_er_seksuelle_overgrep.html"
        },
        {
          "title": "Porno og sex, omtrent det samme?",
          "text": "Noen tenker at porno er det samme som sex, bare at det er filmet og lagt ut på nett, men det er noen viktige forskjeller.",
          "navigateTo": "https://www.ung.no/Sex/4273_Porno,_ikke_bare_greit.html"
        },
        {
          "title": "Hva skjer i hjernen under sex?",
          "text": "Når vi har eller tenker på sex utløses hormonene dopamin og oxytocin i hjernen. Disse hormonene påvirker følelsene våre og kalles ofte for lykkehormonet og kjærlighetshormonet.",
          "navigateTo": "https://www.youtube.com/watch?v=jtkAA-AHFyI&list=PLS9Dbtm5qG5WEs45MOrRM90A-hXHF5_n3&index=2"
        }
      ],
      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": "/temavalg" }]
    },
    {
      "urlPath": "/temavalg/pedofili",
      "title": "Pedofili",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "text": "Hva betyr det å være pedo?",
          "navigateTo": "/temabeskrivelse/hva_betyr_det_a_vere_pedo"
        },
        {
          "id": 2,
          "text": "Er det lov å ha pedofili?",
          "navigateTo": "/temabeskrivelse/er_det_lov_a_ha_pedofili"
        },
        {
          "id": 3,
          "text": "Kan de som har pedofili slutte å ha det?",
          "navigateTo": "/temabeskrivelse/kan_de_som_har_pedofili_slutte_a_ha_det"
        },
        {
          "id": 4,
          "text": "Hva kan jeg gjøre hvis jeg tror jeg har pedofili??",
          "navigateTo": "/temabeskrivelse/hva_kan_jeg_gjore_hvis_jeg_tror_jeg_har_pedofili"
        },
        {
          "id": 5,
          "text": "Er det lov å se på tegneserier med seksualiserte tegninger av barn?",
          "navigateTo": "/temabeskrivelse/er_det_lov_a_se_pa_tegneserier_med_seksualiserte_tegninger_av_barn"
        },
        {
          "id": 6,
          "text": "Hvorfor er det ikke lov å se på videoer eller bilder som viser sex med barn?",
          "navigateTo": "/temabeskrivelse/hvorfor_er_det_ikke_lov_a_se_pa_videoer_eller_bilder_som_viser_sex_med_barn"
        },
        {
          "id": 7,
          "text": "Må jeg snakke med noen hvis jeg tror at jeg har pedofili?",
          "navigateTo": "/temabeskrivelse/ma_jeg_snakke_med_noen_hvis_jeg_tror_at_jeg_har_pedofili"
        }
      ],
      "resources": [
        {
          "title": "Detfinneshjelp.no",
          "text": "Tjenestene i Det finnes hjelp er for personer over 18 år med seksuell interesse for barn, som har en selvidentifisert risiko, og som ønsker hjelp til å unngå å handle på sin seksuelle interesse.",
          "navigateTo": "https://detfinneshjelp.no/"
        }
      ],
      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": "/temavalg" }]
    },
    {
      "urlPath": "/temavalg/porno_og_gaming",
      "title": "Porno og gaming ",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "text": "Noen har vist meg porno",
          "navigateTo": "/temabeskrivelse/noen_har_vist_meg_porno"
        },
        {
          "id": 2,
          "text": "Hva er lov å se på?",
          "navigateTo": "/temabeskrivelse/hva_er_lov_a_se_pa"
        },
        {
          "id": 3,
          "text": "Hvorfor er det aldersgrense på porno?",
          "navigateTo": "/temabeskrivelse/hvorfor_er_det_aldersgrense_pa_porno"
        },
        {
          "id": 4,
          "text": "Jeg ser på porno som viser sex med noen som er i stefamilie med hverandre",
          "navigateTo": "/temabeskrivelse/jeg_ser_pa_porno_som_viser_sex_med_noen_som_er_i_stefamilie_med_hverandre"
        },
        {
          "id": 5,
          "text": "Hvordan kan porno påvirke meg?",
          "navigateTo": "/temabeskrivelse/hvordan_kan_porno_pavirke_meg"
        },
        {
          "id": 6,
          "text": "Hva er hentai - animeporno?",
          "navigateTo": "/temabeskrivelse/hva_er_hentai_animeporno"
        },
        {
          "id": 7,
          "text": "Ser jeg for mye porno",
          "navigateTo": "/temabeskrivelse/ser_jeg_for_mye_porno"
        },
        {
          "id": 8,
          "text": "Kan man bli avhengig av porno?",
          "navigateTo": "/temabeskrivelse/kan_man_bli_avhengig_av_porno"
        },
        {
          "id": 9,
          "text": "Jeg trenger porno for å bli kåt",
          "navigateTo": "/temabeskrivelse/jeg_trenger_porno_for_a_bli_kat"
        },
        {
          "id": 10,
          "text": "Kjæresten min liker ikke at jeg ser på porno",
          "navigateTo": "/temabeskrivelse/kjeresten_min_liker_ikke_at_jeg_ser_pa_porno"
        },
        {
          "id": 11,
          "text": "Jeg bruker porno for å lære om sex",
          "navigateTo": "/temabeskrivelse/jeg_bruker_porno_for_a_lere_om_sex"
        },
        {
          "id": 12,
          "text": "Gutter kan trakassere når de gamer",
          "navigateTo": "/temabeskrivelse/gutter_kan_trakassere_nar_de_gamer"
        }
      ],
      "resources": [
        {
          "title": "Porno og sex, omtrent det samme?",
          "text": "Noen tenker at porno er det samme som sex, bare at det er filmet og lagt ut på nett, men det er noen viktige forskjeller.",
          "navigateTo": "https://www.ung.no/Sex/4273_Porno,_ikke_bare_greit.html"
        },
        {
          "title": "Kan man onanere for mye?",
          "text": "Onanering er helt vanlig og til og med sunt. Men alt som er sunt og vanlig kan også bli for mye. Selv om du ikke får fysiske skader, kan onanering bli problematisk hvis det blir veldig mye av det og det tar for stor plass i livet ditt.",
          "navigateTo": "https://www.youtube.com/watch?v=YbIjTVVDlNo&list=PLS9Dbtm5qG5WEs45MOrRM90A-hXHF5_n3&index=3"
        }
      ],
      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": "/temavalg" }]
    },
    {
      "urlPath": "/temavalg/seksuell_lavalder",
      "title": "Seksuell lavalder",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "text": "Hva telles som sex?",
          "navigateTo": "/temabeskrivelse/hva_telles_som_sex"
        },
        {
          "id": 2,
          "text": "Hvor stor aldersforskjell er lov?",
          "navigateTo": "/temabeskrivelse/hvor_stor_aldersforskjell_er_lov"
        },
        {
          "id": 3,
          "text": "Jeg er over 16 år, kan jeg ha sex med en under 16 år?",
          "navigateTo": "/temabeskrivelse/jeg_er_over_seksten_ar_kan_jeg_ha_sex_med_en_under_seksten_ar"
        },
        {
          "id": 4,
          "text": "Hva skjer med meg hvis jeg er over 16 og har sex med noen under 16 år?",
          "navigateTo": "/temabeskrivelse/hva_skjer_med_meg_hvis_jeg_er_over_seksten_og_har_sex_med_noen_under_seksten_ar"
        },
        {
          "id": 5,
          "text": "Hva kan jeg  gjøre hvis jeg er under 16 år?",
          "navigateTo": "/temabeskrivelse/hva_kan_jeg_gjore_hvis_jeg_er_under_seksten_ar"
        },
        {
          "id": 6,
          "text": "Hva hvis noen over 16 vil ha sex med meg?",
          "navigateTo": "/temabeskrivelse/hva_hvis_noen_over_seksten_vil_ha_sex_med_meg"
        }
      ],
      "resources": [
        {
          "title": "Kan jeg ha sex før jeg fyller 16 år?",
          "text": "Mange lurer på om det er ulovlig å ha sex hvis de selv, eller den de vil ha sex med, er under seksuell lavalder. Her forklarer vi regelverket for sex mellom ungdom.",
          "navigateTo": "https://www.ung.no/Sex/2422_Hva_er_seksuell_lavalder.html"
        },
        {
          "title": "Sex for første gang",
          "text": "Ingen er verdensmester første gang, men hvis du leser litt om sex på forhånd kan du bli litt tryggere.",
          "navigateTo": "https://www.ung.no/Sex/2040_Sex_for_f%C3%B8rste_gang.html"
        },
        {
          "title": "Er det greit å mase seg til sex?",
          "text": "Det er vanlig å glede seg til sex, særlig hvis du håper å ha det med en du liker godt. Men bør du overtale noen til å ha sex med deg?",
          "navigateTo": "https://www.ung.no/Sex/3308_Er_det_greit_%C3%A5_mase_seg_til_sex.html"
        }
      ],
      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": "/temavalg" }]
    },
    {
      "urlPath": "/temavalg/samtykke",
      "title": "Samtykke",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "text": "Hva betyr det å gi samtykke?",
          "navigateTo": "/temabeskrivelse/hva_betyr_det_a_gi_samtykke"
        },
        {
          "id": 2,
          "text": "Hvem kan samtykke?",
          "navigateTo": "/temabeskrivelse/hvem_kan_samtykke"
        },
        {
          "id": 3,
          "text": "Kan andre samtykke for meg?",
          "navigateTo": "/temabeskrivelse/kan_andre_samtykke_for_meg"
        },
        {
          "id": 4,
          "text": "Kan barn samtykke?",
          "navigateTo": "/temabeskrivelse/kan_barn_samtykke"
        },
        {
          "id": 5,
          "text": "Hva kan påvirke samtykke",
          "navigateTo": "/temabeskrivelse/hva_kan_pavirke_samtykke"
        },
        {
          "id": 6,
          "text": "Hvorfor kan ikke en som er full eller rusa gi samtykke?",
          "navigateTo": "/temabeskrivelse/hvorfor_kan_ikke_en_som_er_full_eller_rusa_gi_samtykke"
        },
        {
          "id": 7,
          "text": "Hvordan ser et samtykke ut?",
          "navigateTo": "/temabeskrivelse/hvordan_ser_et_samtykke_ut"
        }
      ],
      "resources": [
        {
          "title": "Sett dine egne grenser og respekter andres",
          "text": "Alle mennesker har grenser. For at vi skal ha det bra og føle oss trygge, må disse grensene respekteres.",
          "navigateTo": "https://www.ung.no/overgrep/3656_Sett_dine_egne_grenser.html"
        },
        {
          "title": "Voldelig relasjon",
          "text": "For deg som lurer på om du er i en voldelig relasjon",
          "navigateTo": "https://www.ungerelasjoner.no/"
        },
        {
          "title": "Kan jeg ha sex før jeg fyller 16 år?",
          "text": "Mange lurer på om det er ulovlig å ha sex hvis de selv, eller den de vil ha sex med, er under seksuell lavalder. Her forklarer vi regelverket for sex mellom ungdom.",
          "navigateTo": "https://www.ung.no/Sex/2422_Hva_er_seksuell_lavalder.html"
        },
        {
          "title": "Hva er samtykke til sex?",
          "text": "Å gi samtykke betyr å si ja, enten med ord eller med kroppsspråk. Du kan få samtykke til å kose, kysse, ta på, fingre, runke, ha sex eller andre ting.",
          "navigateTo": "https://www.ung.no/overgrep/3251_Hva_er_samtykke_til_sex.html"
        },
        {
          "title": "Sånn kan du ta initiativ til sex",
          "text": "Vil du ha sex med noen, men vet ikke helt hvordan du skal vise det? Her er noen gode råd.",
          "navigateTo": "https://www.ung.no/Sex/4494_S%C3%A5nn_kan_du_ta_initiativ_til_sex.html"
        },
        {
          "title": "Er det greit å mase seg til sex?",
          "text": "Det er vanlig å glede seg til sex, særlig hvis du håper å ha det med en du liker godt. Men bør du overtale noen til å ha sex med deg?",
          "navigateTo": "https://www.ung.no/Sex/3308_Er_det_greit_%C3%A5_mase_seg_til_sex.html"
        },
        {
          "title": "Er jeg en overgriper eller risikerer jeg å bli det?",
          "text": "Har du ofte tanker om å gjøre noe seksuelt med andre mot deres vilje, eller med en som er mye yngre enn deg? Eller har du allerede utnyttet noen seksuelt?",
          "navigateTo": "https://www.ung.no/har-du-utsatt-noen-for-overgrep"
        },
        {
          "title": "Hva skjer i hjernen under sex?",
          "text": "Når vi har eller tenker på sex utløses hormonene dopamin og oxytocin i hjernen. Disse hormonene påvirker følelsene våre og kalles ofte for lykkehormonet og kjærlighetshormonet.",
          "navigateTo": "https://www.youtube.com/watch?app=desktop&v=jtkAA-AHFyI&list=PLS9Dbtm5qG5WEs45MOrRM90A-hXHF5_n3&index=1"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": "/temavalg" }]
    },
    {
      "urlPath": "/temavalg/bilder_og_videoer",
      "title": "Nakenbilder og videoer",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "text": "Er det vanlig å sende nakenbilder og dickpics?",
          "navigateTo": "/temabeskrivelse/er_det_vanlig_a_sende_nakenbilder_og_dickpics"
        },
        {
          "id": 2,
          "text": "Hva sier loven?",
          "navigateTo": "/temabeskrivelse/hva_sier_loven"
        },
        {
          "id": 3,
          "text": "Hvilke bilder er lov å sende?",
          "navigateTo": "/temabeskrivelse/hvilke_bilder_er_lov_a_sende"
        },
        {
          "id": 4,
          "text": "Er bildene jeg har lovlige?",
          "navigateTo": "/temabeskrivelse/er_bildene_jeg_har_lovlige"
        },
        {
          "id": 5,
          "text": "Jeg får andre til å sende bilder og videoer til meg",
          "navigateTo": "/temabeskrivelse/jeg_far_andre_til_a_sende_bilder_og_videoer_til_meg"
        },
        {
          "id": 6,
          "text": "Jeg har solgt eller lagt ut bilder av andre",
          "navigateTo": "/temabeskrivelse/jeg_har_solgt_eller_lagt_ut_bilder_av_andre"
        },
        {
          "id": 7,
          "text": "Hvorfor bør jeg ikke selge seksuelle bilder av meg selv?",
          "navigateTo": "/temabeskrivelse/hvorfor_bor_jeg_ikke_selge_seksuelle_bilder_av_meg_selv"
        },
        {
          "id": 8,
          "text": "Jeg har sendt bilder til folk som ikke spurte om dem",
          "navigateTo": "/temabeskrivelse/jeg_har_sendt_bilder_til_folk_som_ikke_spurte_om_dem"
        },
        {
          "id": 9,
          "text": "Andre sender nakenbilder til meg og jeg liker det ikke",
          "navigateTo": "/temabeskrivelse/andre_sender_nakenbilder_til_meg_og_jeg_liker_det_ikke"
        },
        {
          "id": 10,
          "text": "Noen har tatt bilder eller video av meg",
          "navigateTo": "/temabeskrivelse/noen_har_tatt_bilder_eller_video_av_meg"
        },
        {
          "id": 11,
          "text": "Jeg trenger å fjerne private bilder/filmer som har blitt lagt ut",
          "navigateTo": "/temabeskrivelse/jeg_trenger_a_fjerne_private_bilder_filmer_som_har_blitt_lagt_ut"
        },
        {
          "id": 12,
          "text": "Jeg blir presset til å sende nakenbilder",
          "navigateTo": "/temabeskrivelse/jeg_blir_presset_til_a_sende_nakenbilder"
        },
        {
          "id": 13,
          "text": "Jeg har sendt bilder, blir presset til å sende mer",
          "navigateTo": "/temabeskrivelse/jeg_har_sendt_bilder_blir_presset_til_a_sende_mer"
        },
        {
          "id": 14,
          "text": "Er apper hvor folk selger bilder og videoer ulovlige?",
          "navigateTo": "/temabeskrivelse/er_apper_hvor_folk_selger_bilder_og_videoer_ulovlige"
        }
      ],
      "resources": [
        {
          "title": "Kan man legge ut bilder av andre som man selv har tatt?",
          "text": "Hvor går grensen for hvilke bilder man kan legge ut av andre? Er det nok at man har fotografert bildet selv? Her er noen gode råd.",
          "navigateTo": "https://www.ung.no/nettvett/1956_Kan_man_legge_ut_bilder_av_andre_som_man_selv_har_tatt.html"
        },
        {
          "title": "Har du delt nakenbilder av andre?",
          "text": "Har du videresendt et bilde som bare var ment til deg og skjønt at det ikke var en ok ting å gjøre? Her er noen tips til hvordan du kan rydde opp.",
          "navigateTo": "https://www.ung.no/nettvett/4312_Har_du_delt_nakenbilder_av_andre.html"
        },
        {
          "title": "Er det lov å sende nudes eller dickpics?",
          "text": "Det kan være spennende å sende slike bilder, men i mange tilfeller kan det være straffbart. Her er det du trenger å vite om deling av nakenbilder.",
          "navigateTo": "https://www.ung.no/nettvett/4272_Er_det_lov_%C3%A5_sende_nudes_eller_dickpics.html"
        },
        {
          "title": "Sett dine egne grenser og respekter andres",
          "text": "Alle mennesker har grenser. For at vi skal ha det bra og føle oss trygge, må disse grensene respekteres.",
          "navigateTo": "https://www.ung.no/overgrep/3656_Sett_dine_egne_grenser.html"
        },
        {
          "title": "Sånn takler du mas om nudes",
          "text": "Visste du at halvparten av alle tenåringer har blitt spurt om å sende nakenbilder? Her finner du tips til hva du kan gjøre hvis du blir bedt om - eller har lyst til - å sende nudes eller dickpicks.",
          "navigateTo": "https://www.politiet.no/rad/trygg-nettbruk/delbart/bilder-delbart"
        },
        {
          "title": "Hva skjer i hjernen under sex?",
          "text": "Når vi har eller tenker på sex utløses hormonene dopamin og oxytocin i hjernen. Disse hormonene påvirker følelsene våre og kalles ofte for lykkehormonet og kjærlighetshormonet.",
          "navigateTo": "https://www.youtube.com/watch?v=jtkAA-AHFyI"
        },
        {
          "title": "Slettmeg.no",
          "text": "Slettmeg.no er en gratis råd- og veiledningstjeneste for deg som føler deg krenket på nett.",
          "navigateTo": "https://slettmeg.no/"
        },
        {
          "title": "Barnevakten.no",
          "text": "Barnevakten er en fri og selvstendig stiftelse som formidler fakta og råd om barn, unge og medier.",
          "navigateTo": "https://www.barnevakten.no/"
        },
        {
          "title": "Reddbarna.no",
          "text": "Redd Barna har jobbet for barns rettigheter i mer enn 100 år. Vi er en medlemsstyrt rettighetsorganisasjon som er partipolitisk og religiøst nøytral. Her finner du informasjon om organisasjonen Redd Barna, hvem vi er og hvordan vi jobber.",
          "navigateTo": "https://www.reddbarna.no/"
        }
      ],
      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": "/temavalg" }]
    },
    {
      "urlPath": "/temabeskrivelse/hva_betyr_det_a_gi_samtykke",
      "title": "Hva betyr det å gi samtykke?",
      "subtitle": null,
      "ingress1": "Å gi samtykke betyr å gi den andre personen beskjed om hva du har lyst til å gjøre.",
      "ingress2": "Vil du gi samtykke til å kysse? Da kan du enten si “jeg har lyst til å kysse deg” eller du kan vise det med kroppsspråket ditt. Du kan for eksempel lene ansiktet ditt mot ansiktet til den du vil kysse, sånn at ansiktene deres er nærmere enn de vanligvis er. \n\n Før dere kan kysse må den andre personen også samtykke. Kanskje svarer personen at “det har jeg også lyst til” eller samtykker ved å lene seg mot deg eller gi deg et kyss. \n\n Husk at begge må samtykke før dere kan kose, kysse, ta på, fingre, runke, penetrere eller gjøre andre seksuelle ting sammen. \n\n Et samtykke må være ferskt. Det betyr at selv om du har gjort seksuelle ting med noen tidligere, betyr ikke det at de har samtykket til at dere skal ha sex senere.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/samtykke"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvem_kan_samtykke",
      "title": "Hvem kan samtykke?",
      "subtitle": null,
      "ingress1": "Bare du kan gi samtykke for deg. Du kan ikke gi samtykke for andre.",
      "ingress2": "Ingen andre kan samtykke for deg, ikke engang kjæresten din eller en voksen. \n\n Den seksuelle lavalderen i Norge er 16 år. Loven er laget for å beskytte barn mot overgrep fra voksne, ikke for å stoppe to ungdommer i å ha sex med hverandre. \n\n To ungdommer kan derfor samtykke til sex hvis de kan svare ja på alle disse punktene: \n\n\u2022 Begge er over 14 år.\n\u2022 Begge har lyst. \n\u2022 Dere er omtrent like gamle og omtrent like modne både i kropp og i væremåte. \n\u2022 Ingen av dere sover, er fulle eller rusa.",
      "resources": [
        {
          "title": "Er det lov å ha sex med dyr?",
          "text": "Noen ganger får vi i ung.no spørsmål fra unge som enten blir kåte av tanken på dyr eller som forteller at de allerede har hatt sex med dyr.",
          "navigateTo": "https://www.ung.no/er-det-lov-a-ha-sex-med-dyr"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/samtykke"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/kan_andre_samtykke_for_meg",
      "title": "Kan andre samtykke for meg?",
      "subtitle": null,
      "ingress1": "Ingen andre kan samtykke for deg, selv ikke kjæresten din eller en voksen.",
      "ingress2": "Ingen andre kan samtykke for deg. Hvis du gir samtykke fordi du føler deg presset til det, gjelder ikke samtykket.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/samtykke"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/kan_barn_samtykke",
      "title": "Kan barn samtykke?",
      "subtitle": null,
      "ingress1": "Små barn kan ikke samtykke til sex, men eldre ungdommer kan noen ganger samtykke til sex.",
      "ingress2": "Den seksuelle lavalderen i Norge er 16 år fordi barn skal beskyttes mot overgrep fra voksne. Derfor kan to ungdommer likevel samtykke til å ha sex med hverandre hvis dere kan svare ja på alle punktene under: \n\n\u2022 Begge er over 14 år.\n\u2022 Begge har lyst. \n\u2022 Dere er omtrent like gamle og omtrent like modne både i kropp og i væremåte. \n\u2022 Ingen av dere sover, er fulle eller rusa.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/samtykke"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_kan_pavirke_samtykke",
      "title": "Hva kan påvirke samtykke?",
      "subtitle": null,
      "ingress1": "Hvis du er full, rusa, veldig trøtt, usikker eller redd, kan du komme til å si ja til noe du egentlig ikke har lyst til.",
      "ingress2": "For å samtykke til sex må du derfor være edru, våken og føle deg trygg på personen du gir samtykke til. \n\n Du kan ikke ha sex med en som sover selv om personen samtykket før hen sovnet. \n\n Oppfører den andre seg yngre enn sin alder eller yngre enn deg? En som er umoden for alderen kan komme til å si ja til noe personen egentlig ikke er klar for å gjøre.",
      "resources": [
        {
          "title": "Hvorfor har vi følelser og hvordan lytte til dem?",
          "text": "Blir du sint eller redd på feil tidspunkt, eller er følelsene dine så kraftige at andre blir redde eller bekymert? Det kan du heldigvis gjøre noe med!",
          "navigateTo": "https://www.ung.no/hvorfor-har-vi-folelser-og-hvordan-lytte-til-dem"
        },
        {
          "title": "Sånn påvirker alkohol kroppen din",
          "text": "Kort tid etter at du drikker alkohol, vil du begynne å kjenne virkningene. Hvordan påvirker alkohol kroppen din, og hvordan kan du bruke rusmiddelet på smartest mulig måte?",
          "navigateTo": "https://www.ung.no/rusmidler/alkohol/2015_S%C3%A5nn_p%C3%A5virker_alkohol_kroppen_din.html"
        },
        {
          "title": "Sett dine egne grenser og respekter andres",
          "text": "Alle mennesker har grenser. For at vi skal ha det bra og føle oss trygge, må disse grensene respekteres.",
          "navigateTo": "https://www.ung.no/overgrep/3656_Sett_dine_egne_grenser.html"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/samtykke"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvorfor_kan_ikke_en_som_er_full_eller_rusa_gi_samtykke",
      "title": "Hvorfor kan ikke en som er full eller rusa gi samtykke?",
      "subtitle": null,
      "ingress1": "Alkohol og rus forandrer både følelsene og tankene våre. Følelsene kan bli sterkere og tankene blir ofte uklare og annerledes.",
      "ingress2": "1. For noen gjør alkohol og rus at de blir kåtere og tar mindre hensyn til andre. \n\n 2. For andre gjør alkohol og rus at de blir med på ting de ellers ville sagt nei til. \n\n 3.     Ingen skal gjøre noe seksuelt som de egentlig ikke har lyst til. Samtykke som blir gitt når man er full eller rusa gjelder derfor ikke.",
      "resources": [
        {
          "title": "Sånn påvirker alkohol kroppen din",
          "text": "Kort tid etter at du drikker alkohol, vil du begynne å kjenne virkningene. Hvordan påvirker alkohol kroppen din, og hvordan kan du bruke rusmiddelet på smartest mulig måte?",
          "navigateTo": "https://www.ung.no/rusmidler/alkohol/2015_S%C3%A5nn_p%C3%A5virker_alkohol_kroppen_din.html"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/samtykke"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvordan_ser_et_samtykke_ut",
      "title": "Hvordan ser et samtykke ut?",
      "subtitle": null,
      "ingress1": "Et samtykke kan være lett eller vanskelig å få med seg. Noen ganger merker du det ved at personen sier det, andre ganger må du lese kroppsspråk. Er du i tvil, så spør den andre om hen  vil.",
      "ingress2": "Det er vanlig at en som samtykker for eksempel smiler og lener seg mot deg, tar rundt deg eller trekker deg inntil seg. At den andre er stille og ikke sier “nei”, betyr ikke at de samtykker. \n\n Et eksempel på å gi samtykke til sex med kroppsspråk kan være å legge et kondom i hånda på den andre mens man kysser. Nå har den som ga kondomet samtykket til sex, så lenge kondomet blir brukt. Hvis den andre frivillig åpner kondomet og tar det på, har personen vist tydelig med kroppen at hen også har lyst. Dette regnes som samtykke og de to kan ha sex. \n\n Uansett hvilken måte du har samtykket på, så husk at du når som helst kan ombestemme deg.",
      "resources": [
        {
          "title": "Sånn kan du ta initiativ til sex",
          "text": "Vil du ha sex med noen, men vet ikke helt hvordan du skal vise det? Her er noen gode råd.",
          "navigateTo": "https://www.ung.no/Sex/4494_S%C3%A5nn_kan_du_ta_initiativ_til_sex.html"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/samtykke"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_telles_som_sex",
      "title": "Hva telles som sex?",
      "subtitle": null,
      "ingress1": "Mange vil si at sex er å ta på, være inntil eller inni hverandres kjønnsorgan.",
      "ingress2": "Sex kan også være å berøre hverandre på en seksuell måte uten at kjønnsorganet er involvert. Det å ha sex med seg selv kalles onanering. \n\n De fleste er enige i at sex kan være mer enn at penis føres inn i vagina. Man kan for eksempel bruke bevegelse, hender, fingre eller kroppsvekt for å gjøre det deilig for begge. \n\n Hvordan man har sex kommer an på hva man liker å gjøre, hvor mye erfaring man har fra før og hvem som har sex.",
      "resources": [
        {
          "title": "Hva gjør at du blir kåt?",
          "text": "Hva som gjør oss kåte varierer fra person til person. De fleste har et eller annet som tenner dem litt ekstra seksuelt. Noen blir sjelden kåte, mens andre blir det ofte.",
          "navigateTo": "https://www.ung.no/Sex/4035_Hva_gj%C3%B8r_at_du_blir_k%C3%A5t.html"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/seksuell_lavalder"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvor_stor_aldersforskjell_er_lov",
      "title": "Hvor stor aldersforskjell er lov?",
      "subtitle": null,
      "ingress1": "Så lenge begge er 16 år eller eldre er det ingen lover som sier noe om hvor stor aldersforskjell det kan være.",
      "ingress2": "Selv om det ikke er forbudt kan stor aldersforskjell lage en del problemer i et forhold, fordi man ofte har forskjellige erfaringer og behov..",
      "resources": [
        {
          "title": "Hva gjør at du blir kåt?",
          "text": "Hva som gjør oss kåte varierer fra person til person. De fleste har et eller annet som tenner dem litt ekstra seksuelt. Noen blir sjelden kåte, mens andre blir det ofte.",
          "navigateTo": "https://www.ung.no/Sex/4035_Hva_gj%C3%B8r_at_du_blir_k%C3%A5t.html"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/seksuell_lavalder"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/jeg_er_over_seksten_ar_kan_jeg_ha_sex_med_en_under_seksten_ar",
      "title": "Jeg er over 16 år, kan jeg ha sex med en under 16 år?",
      "subtitle": null,
      "ingress1": "Kanskje, men les dette først:",
      "ingress2": "Norsk lov sier at det er forbudt for en som er over 16 å ha sex med en som er under 16 år. \n\n Loven er laget for å beskytte barn mot overgrep fra voksne, ikke for å stoppe to ungdommer i å ha sex med hverandre. \n\n Derfor er det veldig sjeldent at en ung person blir straffet for å ha sex med en som er under 16 år, så lenge de to var på omtrent samme alder, har lik modenhet og begge samtykket.",
      "resources": [
        {
          "title": "Hva er samtykke til sex?",
          "text": "Å gi samtykke betyr å si ja, enten med ord eller med kroppsspråk. Du kan få samtykke til å kose, kysse, ta på, fingre, runke, ha sex eller andre ting.",
          "navigateTo": "https://www.ung.no/overgrep/3251_Hva_er_samtykke_til_sex.html"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/seksuell_lavalder"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_skjer_med_meg_hvis_jeg_er_over_seksten_og_har_sex_med_noen_under_seksten_ar",
      "title": "Hva skjer med meg hvis jeg er over 16 og har sex med noen under 16 år?",
      "subtitle": null,
      "ingress1": "Det kommer an på situasjonen.",
      "ingress2": "Hvis personen er flere år yngre enn deg og under 14 år, oppfører seg yngre enn sin alder eller ikke gir samtykke, kan du bli anmeldt og dømt til ungdomsstraff eller fengsel. \n\n Sex mellom ungdom som er nær hverandre i alder, like modne, og begge vil det, vil vanligvis ikke bli straffet. \n\n Svarer dere ja på alle punktene under, er det liten sannsynlighet for at du blir straffet. \n\u2022 Begge er over 14 år. \n\u2022 Begge har lyst. \n\u2022 Dere er omtrent like gamle og omtrent like modne både i kropp og i hode.. \n\u2022 Ingen av dere sover, er fulle eller rusa.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/seksuell_lavalder"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_kan_jeg_gjore_hvis_jeg_er_under_seksten_ar",
      "title": "Hva kan jeg gjøre hvis jeg er under 16 år?",
      "subtitle": null,
      "ingress1": "Det er mange ting dere kan gjøre selv om dere er under 16 år.",
      "ingress2": "Dere har lov til å kysse, stryke på, klemme, holde hender, se hverandre nakne, ligge inntil hverandre eller være kjærester. \n\n Uansett hvor gammel du er har du alltid lov til å onanere alene.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/seksuell_lavalder"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_hvis_noen_over_seksten_vil_ha_sex_med_meg",
      "title": "Hva hvis noen over 16 vil ha sex med meg?",
      "subtitle": null,
      "ingress1": "Det kommer an på hvor gammel du er.",
      "ingress2": "Er du 16 år eller eldre? Hvis begge samtykker kan dere ha sex. \n\n Er du yngre enn 16 år? Da kan personen bli straffet hvis dere har sex, selv om du ville det. \n\n Sex mellom ungdom som er nær hverandre i alder, like modne, og begge vil det, vil vanligvis ikke bli straffet. \n\n Er personen flere år eldre enn deg eller er hen for eksempel treneren din eller på annen måte en leder for deg? Da kan det gi en maktskjevhet mellom dere som kan gjøre at du føler at du må ha sex med hen. Personen kan da bli straffet hvis dere har sex, selv om du ga samtykke. \n\n Syns du ofte at det er vanskelig å si nei? Snakk med en voksen du stoler på, helsesykepleier eller chatten til Sex og Samfunn. Her kan du få gode råd til hvordan du kan klare å si nei, hvis du skulle trenge det.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Hva er samtykke til sex?",
          "text": "Å gi samtykke betyr å si ja, enten med ord eller med kroppsspråk. Du kan få samtykke til å kose, kysse, ta på, fingre, runke, ha sex eller andre ting.",
          "navigateTo": "https://www.ung.no/overgrep/3251_Hva_er_samtykke_til_sex.html"
        },
        {
          "title": "Aldersforskjell i kjæresteforhold",
          "text": "Er det sånn at kjærlighet ikke kjenner noen alder? Kan det gå bra i et kjæresteforhold med stor aldersforskjell? Ungdomsjournalist Hege har sett litt på hvilke utfordringer dere kan møte.",
          "navigateTo": "https://www.ung.no/forelskelse/2853_Aldersforskjell_i_kj%C3%A6resteforhold.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/seksuell_lavalder"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/er_det_vanlig_a_sende_nakenbilder_og_dickpics",
      "title": "Er det vanlig å sende nakenbilder og dickpics?",
      "subtitle": null,
      "ingress1": "1 av 10 unge har sendt nakenbilder eller dickpics av seg selv. Det betyr at 9 av 10 ikke har gjort det.",
      "ingress2": "Vurderer du å sende nakenbilder til en som har spurt deg om det? Da kan det være lurt å lese videre. \n\n Det er dessverre ikke uvanlig at private bilder blir delt videre. Noen blir også truet til å sende flere bilder eller drøyere innhold. \n\n Det å dele private bilder eller video av andre er ulovlig, uansett hvordan man fikk tak i innholdet.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_sier_loven",
      "title": "Hva sier loven?",
      "subtitle": null,
      "ingress1": "Det er ulovlig å dele eller legge ut seksuelle bilder av andre, uansett hvordan du fikk tak i det og uansett hvor gammel personen på bildene er.",
      "ingress2": "Det er straffbart å ta, ha eller dele seksuelle bilder eller video av noen som er under 18 år, uansett om du har fått innholdet av personen på bildene eller av noen andre. \n\n Hvis dere kjenner hverandre godt, begge syns det er greit og dere er omtrent like gamle og modne, blir dere vanligvis ikke straffet for å ha bilder og video av hverandre. \n\n Tenker du på å sende nakenbilder av deg selv til noen som ikke har bedt om det? Det blir regnet som digital blotting og er noe du risikerer å bli dømt og straffet for om du er 15 år eller eldre.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvilke_bilder_er_lov_a_sende",
      "title": "Hvilke bilder er lov å sende?",
      "subtitle": null,
      "ingress1": "Det er lov å sende flørtende bilder! Usikker på hva som er innafor? Ta denne testen:",
      "ingress2": "Se for deg at bildet blir delt med noen andre enn personen du sendte det til. Det kan være noen i klassen eller en voksen du kjenner. Hvis det hadde føltes veldig ille, bør du kanskje ikke sende bildet.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/er_bildene_jeg_har_lovlige",
      "title": "Er bildene jeg har lovlige?",
      "subtitle": null,
      "ingress1": "Har du nakenbilder av noen under 18 år, bilder av noen som ikke vet at du har dem eller som ikke hadde lyst til å dele dem med deg? Da er bildene ulovlige.",
      "ingress2": "Det er ulovlig å beholde bildene selv om du ikke har tenkte til å vise dem til andre. \n\n Er du usikker på om det du har er greit? Slett det du har, så er både du og den på bildene på den sikre siden.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/jeg_far_andre_til_a_sende_bilder_og_videoer_til_meg",
      "title": "Jeg får andre til å sende bilder og videoer til meg",
      "subtitle": null,
      "ingress1": "Det er ikke lov å true, mase om eller å lure noen til å sende nakenbilder.",
      "ingress2": "Det er også straffbart å lure eller true med å skade seg selv hvis personen ikke sender det du vil ha.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Er det greit å mase seg til sex?",
          "text": "Det er vanlig å glede seg til sex, særlig hvis du håper å ha det med en du liker godt. Men bør du overtale noen til å ha sex med deg?",
          "navigateTo": "https://www.ung.no/Sex/3308_Er_det_greit_%C3%A5_mase_seg_til_sex.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/jeg_har_solgt_eller_lagt_ut_bilder_av_andre",
      "title": "Jeg har solgt eller lagt ut bilder av andre",
      "subtitle": null,
      "ingress1": "Det er ulovlig å vise frem, videresende, dele, legge ut eller å selge seksuelle bilder eller video av andre.",
      "ingress2": "Det er forbudt uansett hvor gammel personen på bildene er og hvem som sendte deg innholdet.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvorfor_bor_jeg_ikke_selge_seksuelle_bilder_av_meg_selv",
      "title": "Hvorfor bør jeg ikke selge seksuelle bilder av meg selv?",
      "subtitle": null,
      "ingress1": "De fleste som selger seksuelle bilder eller video av seg selv tenker ikke at de selger sex.",
      "ingress2": "Noen av dem som selger bilder eller video av seg selv føler at det er de som sitter med kontrollen. Det kan føles spennende og man kan bli “hekta” på følelsen, men mange opplever at situasjonen plutselig snur. Den som har bilder av deg kan dele dem med andre eller bruke dem til å presse deg til å sende flere.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/jeg_har_sendt_bilder_til_folk_som_ikke_spurte_om_dem",
      "title": "Jeg har sendt bilder til folk som ikke spurte om dem",
      "subtitle": null,
      "ingress1": "Det er forbudt å sende seksuelle bilder til noen som ikke har bedt om det, uansett hvor gamle de er",
      "ingress2": "Mange opplever at det er ubehagelig eller skremmende å få sånne bilder. \n\n Er du er usikker på om du har gått over grensen? Kan du sende en melding og spørre om de syns det var greit? Hvis du har flere spørsmål eller trenger noen å snakke med kan du ta kontakt med den anonyme chattetjenesten under.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/andre_sender_nakenbilder_til_meg_og_jeg_liker_det_ikke",
      "title": "Andre sender nakenbilder  til meg og jeg liker det ikke",
      "subtitle": null,
      "ingress1": "Det er ulovlig å sende seksuelle bilder eller innhold til noen som ikke har bedt om det.",
      "ingress2": "Har du prøvd å si at du ikke vil ha det eller blokkert personen? Hvis du føler seg plaget kan du melde personen til politiet.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/noen_har_tatt_bilder_eller_video_av_meg",
      "title": "Noen har tatt bilder eller video av meg",
      "subtitle": null,
      "ingress1": "Ingen har lov til å ta bilder eller video  av deg uten ditt samtykke, uansett hvor gammel du er.",
      "ingress2": "Har noen tatt intime eller seksuelle bilder eller video  av deg eller er du redd for at de skal gjøre det? Da kan du fortelle dem at det er ulovlig. Du kan også kontakte slettmeg.no eller melde personen til politiet. \n\n Hvis du er under 18 år regnes dette som overgrepsmateriale, som er enda mer alvorlig. Snakk med en voksen du stoler på og fortell dem hva som har skjedd. Du kan også anmelde personen til politiet.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/jeg_trenger_a_fjerne_private_bilder_filmer_som_har_blitt_lagt_ut",
      "title": "Jeg trenger å fjerne private bilder/filmer som har blitt lagt ut",
      "subtitle": null,
      "ingress1": "Slettmeg.no har hjulpet mange som har opplevd akkurat det samme som deg.",
      "ingress2": "De kan blant annet hjelpe deg å slette noe som har blitt lagt ut på nett. De kan også gi deg råd hvis du er redd for at det kommer til å skje.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Slik sletter du informasjon om deg på nett",
          "text": "Har du funnet informasjon om deg som du vil ha vekk? Eller vil du slette deg fra en tjeneste? Her er noen tips.",
          "navigateTo": "https://www.ung.no/nettvett/2541_Slik_sletter_du_informasjon_om_deg_p%C3%A5_nett.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/jeg_blir_presset_til_a_sende_nakenbilder",
      "title": "Jeg blir presset til å sende nakenbilder",
      "subtitle": null,
      "ingress1": "Det er forbudt å presse andre til å sende seksuelle bilder, videoer eller lignende.",
      "ingress2": "Hvis du syns at det er ubehagelig eller du syns det er vanskelig å si nei kan du snakke med en du stoler på eller kontakte hjelpetjenesten under. Du kan også melde personen til politiet.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Slik sletter du informasjon om deg på nett",
          "text": "Har du funnet informasjon om deg som du vil ha vekk? Eller vil du slette deg fra en tjeneste? Her er noen tips.",
          "navigateTo": "https://www.ung.no/nettvett/2541_Slik_sletter_du_informasjon_om_deg_p%C3%A5_nett.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/jeg_har_sendt_bilder_blir_presset_til_a_sende_mer",
      "title": "Jeg har sendt bilder, blir presset til å sende mer",
      "subtitle": null,
      "ingress1": "Personen som prøver å presse eller overtale deg til å sende nakenbilder bryter loven. Det er forbudt å presse andre til å sende intime bilder, uansett om du har sendt liknende bilder før eller ikke.",
      "ingress2": "Noen opplever å bli presset med meldinger som “jeg sender bildene jeg har av deg til vennene eller familien din”. \n\n Uansett hvordan de prøver å presse deg; ikke send flere bilder. Snakk i stedet med en voksen du stoler på, selv om det kan føles flaut eller ubehagelig. Du kan også melde personen til politiet. \n\n Husk at det er den andre personen som bryter loven og burde være flau, ikke du.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Slik sletter du informasjon om deg på nett",
          "text": "Har du funnet informasjon om deg som du vil ha vekk? Eller vil du slette deg fra en tjeneste? Her er noen tips.",
          "navigateTo": "https://www.ung.no/nettvett/2541_Slik_sletter_du_informasjon_om_deg_p%C3%A5_nett.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/er_apper_hvor_folk_selger_bilder_og_videoer_ulovlige",
      "title": "Er apper hvor folk selger bilder og videoer ulovlige?",
      "subtitle": null,
      "ingress1": "Det fins ulike apper hvor noen selger seksuelle bilder eller videoer av seg selv til abonnenter.",
      "ingress2": "Det er ikke ulovlig å selge seksuelt innhold av seg selv på slike apper, men de  kan risikere at innholdet blir delt videre med andre.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/bilder_og_videoer"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvordan_vet_jeg_om_jeg_har_trakket_over_andres_grenser",
      "title": "Hvordan vet jeg om jeg har tråkket over andres grenser?",
      "subtitle": null,
      "ingress1": "Det er ikke alltid lett å vite hvor andres grense går.",
      "ingress2": "En som får grensene sine tråkket over kan bli sint, virke redd eller stresset, eller trekke seg unna. Andre ser ikke ut til å reagere i det hele tatt, men det kan være fordi de skjuler det eller blir så redd at de stivner helt. \n\n Er du usikker på om du har tråkket over andres grenser? Det beste er at du spør dem det gjelder, om du lurer. Eller du kan snakke med en voksen du stoler på og forklare hva du gjorde og hvordan du oppfattet at den andre reagerte.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Er det lov å sende nudes eller dickpics?",
          "text": "Det kan være spennende å sende slike bilder, men i mange tilfeller kan det være straffbart. Her er det du trenger å vite om deling av nakenbilder.",
          "navigateTo": "https://www.ung.no/nettvett/4272_Er_det_lov_%C3%A5_sende_nudes_eller_dickpics.html"
        },
        {
          "title": "Er jeg en overgriper eller risikerer jeg å bli det?",
          "text": "Har du ofte tanker om å gjøre noe seksuelt med andre mot deres vilje, eller med en som er mye yngre enn deg? Eller har du allerede utnyttet noen seksuelt?",
          "navigateTo": "https://www.ung.no/har-du-utsatt-noen-for-overgrep"
        },
        {
          "title": "Hva betyr det å være pedo?",
          "text": "Visste du at barn og ungdommer ikke kan være pedo?",
          "navigateTo": "https://www.ung.no/hva-betyr-det-a-vaere-pedo"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/mine_og_andres_grenser"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvordan_vet_jeg_om_noen_har_trakket_over_grensene_mine",
      "title": "Hvordan vet jeg om noen har tråkket over grensene mine?",
      "subtitle": null,
      "ingress1": "Når noen tråkker over dine seksuelle grenser, føles det ofte veldig ubehagelig.",
      "ingress2": "Du kan bli svimmel og kvalm, begynne å skjelve og kaldsvette, og føle deg sint, redd, forvirret eller lei seg. Noen klarer ikke å konsentrere seg eller tenke klart, og klarer ikke si noe.  Det kan gi en følelse av å bli invadert, kanskje du “forsvinner inn i seg selv”. Noen får skyldfølelse fordi de føler at de ikke sa ifra tydelig nok at de ikke hadde lyst. \n\n Ubehaget kan komme med en gang eller når du tenker tilbake på det etterpå. \n\n Det er bare du som bestemmer hvor dine grenser går.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Hvorfor føles det ekkelt å bli tatt på?",
          "text": "Noen elsker å bli tatt på. Andre hater det. Det kan være vanskelig å forstå hvordan noe kan kjennes så forskjellig fra person til person.",
          "navigateTo": "https://www.ung.no/hvorfor-foles-det-ekkelt-a-bli-tatt-pa"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/mine_og_andres_grenser"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvordan_respektere_andres_grenser",
      "title": "Hvordan respektere andres grenser?",
      "subtitle": null,
      "ingress1": "For å respektere andres grenser må du vite hvor de går.",
      "ingress2": "Det kan være vanskelig å vite hvor andres grenser går, spesielt når dere holder på å bli kjent. \n\n Du kan spørre, lytte til det den andre sier, følge med på den andres ansiktsuttrykk og kroppsspråk, eller prøve deg forsiktig frem med berøringer. Stopp med en gang du merker at den andre ikke virker helt med eller oppfører seg på en måte som gjør det usikker på om han eller hun vil. \n\n Snakk sammen og spør hverandre hvis dere lurer på hva den andre liker og har lyst til.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Hvorfor har vi følelser og hvordan lytte til dem?",
          "text": "Blir du sint eller redd på feil tidspunkt, eller er følelsene dine så kraftige at andre blir redde eller bekymert? Det kan du heldigvis gjøre noe med!",
          "navigateTo": "https://www.ung.no/hvorfor-har-vi-folelser-og-hvordan-lytte-til-dem"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/mine_og_andres_grenser"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_skjer_med_meg_hvis_jeg_har_gjort_noe_seksuelt_uten_at_den_andre_samtykket",
      "title": "Hva skjer med meg hvis jeg har gjort noe seksuelt uten at den andre samtykket?",
      "subtitle": null,
      "ingress1": "Det kommer an på alderen din og hva du har gjort.",
      "ingress2": "Hvis du er 15 år eller eldre kan du bli straffet hvis noen anmelder deg. Det mest vanlige da, er å bli dømt til noe som heter ungdomstraff eller ungdomsoppfølging. Da slipper man å sitte i fengsel. Eldre ungdom som har begått veldig alvorlige seksuelle lovbrudd mot noen som ikke samtykket, eller var i stand til å samtykke, kan komme i ungdomsfengsel. \n\n Hvis du er yngre enn 15 eller det du gjorde var mindre alvorlig, blir du ikke straffet. Likevel kan det hende at du får oppfølging på en annen måte, hvis du trenger det. \n\n Snakk med en du stoler på. Kanskje vil personen berolige deg med at det du gjorde ikke er så alvorlig likevel. Det kan også hende at personen er enig i at det er alvorlig. Uansett kan det være godt å dele bekymringen med noen andre. \n\n Hvis du ikke har lyst til å dele det med noen du kjenner kan du chatte med Sex & Samfunn eller stille et anonymt spørsmål her på ung.no.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Er det lov å sende nudes eller dickpics?",
          "text": "Det kan være spennende å sende slike bilder, men i mange tilfeller kan det være straffbart. Her er det du trenger å vite om deling av nakenbilder.",
          "navigateTo": "https://www.ung.no/nettvett/4272_Er_det_lov_%C3%A5_sende_nudes_eller_dickpics.html"
        },
        {
          "title": "Er jeg en overgriper eller risikerer jeg å bli det?",
          "text": "Har du ofte tanker om å gjøre noe seksuelt med andre mot deres vilje, eller med en som er mye yngre enn deg? Eller har du allerede utnyttet noen seksuelt?",
          "navigateTo": "https://www.ung.no/har-du-utsatt-noen-for-overgrep"
        },
        {
          "title": "Hva betyr det å være pedo?",
          "text": "Visste du at barn og ungdommer ikke kan være pedo?",
          "navigateTo": "https://www.ung.no/hva-betyr-det-a-vaere-pedo"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/mine_og_andres_grenser"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/jeg_blir_kat_av_noe_veldig_rart_hva_er_normalt",
      "title": "Jeg blir kåt av noe veldig rart. Hva er normalt?",
      "subtitle": null,
      "ingress1": "Det finnes så mange forskjellige fantasier at det er umulig å si at noe er unormalt.",
      "ingress2": "Noen fantasier er veldig vanlige, mens andre kan være mindre vanlige. Noen fantasier er mer vanlige hos gutter enn hos jenter. Noen fantasier kan være vanligere hos de som tenner seksuelt på personer av samme kjønn som seg selv, enn for de som tenner seksuelt på det motsatte kjønn. \n\n Fantasier kan være både morsomme, rare, litt flaue eller pinlige. \n\n Noen blir for eksempel kåte av tær, kosedyr eller tanken på å ha sex på et offentlig sted. Det å bli kåt av noe og fantasere om det, er ikke det samme som at man vil eller kan gjøre det i virkeligheten.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/tanker_og_fantasier"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/finnes_det_ulovlige_fantasier",
      "title": "Finnes det ulovlige fantasier?",
      "subtitle": null,
      "ingress1": "Nei, ingen tanker eller fantasier er ulovlige.",
      "ingress2": "Har du har sexfantasier om noen i familien din, barn som er flere år yngre enn deg eller dyr? Det kan være vanskelig å ha sånne tanker, men så lenge det bare er tanker så skader du ikke andre. \n\n Det er slitsomt å bære på hemmeligheter alene. Derfor kan være lurt å dele tankene med en voksen du stoler på. Det kan også hende at personen kan hjelpe deg å tenke mindre på disse tingene.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/tanker_og_fantasier"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_er_forskjellen_pa_tanker_og_handling",
      "title": "Hva er forskjellen på tanker og handling?",
      "subtitle": null,
      "ingress1": "En tanke finnes bare inne i hodet ditt og kan ikke skade andre.",
      "ingress2": "En handling er noe du gjør. Noen handlinger kan skade andre. \n\n Mange handlinger starter med en tanke, men ikke alle tanker blir til handlinger. \n\n Mange handlinger starter med en tanke, men ikke alle tanker blir til handlinger.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Hva betyr det å være pedo?",
          "text": "Visste du at barn og ungdommer ikke kan være pedo?",
          "navigateTo": "https://www.ung.no/hva-betyr-det-a-vaere-pedo"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/tanker_og_fantasier"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/kulturen_eller_religionen_min_sier_at_det_er_feil_a_vere_kat_eller_tenke_pa_sex_hva_kan_jeg_gjore",
      "title": "Kulturen eller religionen min sier at det er feil å være kåt eller tenke på sex. Hva kan jeg gjøre?",
      "subtitle": null,
      "ingress1": "Det er umulig å ha full kontroll på tankene sine hele tiden. Ingen trenger å føle seg skamfull eller uren for å ha naturlige tanker og følelser.",
      "ingress2": "Når du er ung er det spesielt vanskelig å unngå ha sextanker eller å bli kåt. \n\n Nesten alle har seksuelle tanker og fantasier, uansett hvilken kultur eller religion de tilhører. Sextanker og fantasier kommer ofte helt av seg selv og er en naturlig del av det å bli eldre. \n\n Forskjellige kulturer og religioner har ulikt syn på hva sex er og hvem som bør ha det.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/tanker_og_fantasier"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_om_jeg_fantaserer_om_familiemedlemmer",
      "title": "Hva om jeg fantaserer om familiemedlemmer",
      "subtitle": null,
      "ingress1": "Seksuelle tanker om noen i familien er ikke så uvanlig, særlig når man er tidlig i tenårene, men de kan være uheldig for deg hvis tankene tar mye plass eller gjør deg bekymret.",
      "ingress2": "En av grunnene til at sex med noen i nær familie er ulovlig er at i en familierelasjon, er relasjonen skjev. Det å gjøre noe seksuelt med noen i familien kan derfor skade familieforholdet. \n\n Det er ulovlig  for foreldre og besteforeldre å gjøre seksuelle handlinger på barna eller barnebarna sine. Det er forbudt uansett om det er biologiske bånd mellom dere eller ikke. Det betyr at sex mellom en steforelder og et stebarn også er ulovlig. Eller et barn som er adoptert inn i familien. \n\n Seksuelle tanker om noen i familien kan komme av at man selv har blitt utsatt for noe seksuelt fra noen i familien, uansett hvem det er. Hvis du har opplevd dette kan du ta kontakt med chattetjenestene under. \n\n Tanker alene skader ikke andre og kan derfor ikke være forbudte. Det er ikke ulovlig å ha seksuelle fantasier om familiemedlemmer.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Intimitet eller sex med noen i familien?",
          "text": "På ung.no får vi spørsmål om hva som er greit og ikke greit av nærhet og berøring. Også når det gjelder søsken og andre i familien.",
          "navigateTo": "https://www.ung.no/overgrep/3419_Intimitet_eller_sex_med_noen_i_familien.html"
        },
        {
          "title": "Kan det være feil å onanere?",
          "text": "Onanerer du mye til porno, så mye at du ikke får nok tid til å gjøre andre ting? Eller onanerer du på en måte som andre reagerer negativt på?",
          "navigateTo": "https://www.ung.no/kan-det-vaere-feil-a-onanere"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/tanker_og_fantasier"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_om_jeg_fantaserer_om_dyr",
      "title": "Hva om jeg fantaserer om dyr",
      "subtitle": null,
      "ingress1": "Det er ikke uvanlig å ha seksuelle fantasier om mange forskjellige ting.",
      "ingress2": "Det å fantasere om noe betyr ikke det samme som at du kommer til å gjøre det og derfor er det ingen tanker som er forbudte. \n\n Det å ha sex med dyr er forbudt. Dyr kan ikke samtykke til sex med mennesker og de kan skades av det. \n\n Hvis tankene tar mye plass eller gjør deg bekymret, kan du kontakte chattetjenesten under.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Er det lov å ha sex med dyr?",
          "text": "Noen ganger får vi i ung.no spørsmål fra unge som enten blir kåte av tanken på dyr eller som forteller at de allerede har hatt sex med dyr. ",
          "navigateTo": "https://www.ung.no/er-det-lov-a-ha-sex-med-dyr"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/tanker_og_fantasier"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvordan_kan_jeg_bli_kvitt_ubehagelige_fantasier",
      "title": "Hvordan kan jeg bli kvitt ubehagelige fantasier?",
      "subtitle": null,
      "ingress1": "Det kan hjelpe å styre tankene over på andre ting som kan gjøre deg kåt.",
      "ingress2": "Bestem deg før du er kåt for hva du har lyst til å tenke på neste gang du onanerer. Eller forsøk å onanere uten å fantasere, men bare kjenne etter hvor godt det føles i kroppen. \n\n Hvis dette ikke hjelper bør du kanskje snakke med noen eller du kan chatte anonymt fra lenken under. \n\n Prøv å ikke stresse dersom det er vanskelig å styre tankene. Husk at fantasier forandrer seg over tid. Tankene du har nå kan forsvinne av seg selv når du blir litt eldre.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/tanker_og_fantasier"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_er_blotting",
      "title": "Hva er blotting?",
      "subtitle": null,
      "ingress1": "Det å blotte seg er vanligvis å få nytelse av å vise kjønnsorganet sitt på et offentlig sted eller til noen som ikke har samtykket til det.",
      "ingress2": "Andre grunner til blotting kan være å ville ha bekreftelse, få kontakt med andre, eller som uttrykk for frustrasjon. \n\n Det er ulovlig å vise kjønnsorganet sitt til noen som ikke har samtykket til det. Det kan oppleves veldig ubehagelig  eller skremmende for den som blir utsatt for det. \n\n Det å sende nakenbilder eller dickpics til noen som ikke har bedt om det regnes som digital blotting og er ulovlig.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/tanker_og_fantasier"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/kan_jeg_kikke_pa_noen_som_gjor_noe_privat_uten_at_de_vet_det",
      "title": "Kan jeg kikke på noen som gjør noe privat uten at de vet det?",
      "subtitle": null,
      "ingress1": "Det er ikke lov  å med vilje kikke på noen som tror de er alene. Det er likevel ikke en uvanlig fantasi.",
      "ingress2": "Ingen fantasier er ulovlige. Du kan derfor fantasere om å kikke på noen, men å gjøre det i virkeligheten er ikke lov. Hvis du er over 15 år og kikker på noen i smug mens de dusjer, kler av seg eller har sex, uten at de vet at du ser på, kan du få straff. \n\n Det å bli kikket på mens man tror man er alene og gjør noe privat, kan føles ubehagelig og oppleves utrygt.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/tanker_og_fantasier"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/har_jeg_lov_til_a_ta_andres_undertoy",
      "title": "Har jeg lov til å ta andres undertøy?",
      "subtitle": null,
      "ingress1": "Nei. Det er ikke lov å ta andres undertøy.",
      "ingress2": "Det er likevel ikke uvanlig å fantasere om andres undertøy. \n\n Undertøy er veldig privat. Hvis noen tar undertøyet ditt, kan dette føles veldig ubehagelig.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/tanker_og_fantasier"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/onanerer_jeg_for_mye",
      "title": "Onanerer jeg for mye?",
      "subtitle": null,
      "ingress1": "Det finnes ikke en klar grense for hva som er for mye onanering.",
      "ingress2": "Hvis du onanerer så mye at du ikke får tid eller orker å gjøre andre ting kan det hende at du gjør det for mye.",
      "resources": [
        {
          "title": "Kåthet, onanering og orgasme",
          "text": "I puberteten øker mengden hormoner som gir seksuell. Når kåtheten øker, er det naturlig at nysgjerrigheten på sex også øker.",
          "navigateTo": "https://www.ung.no/Sex/4136_K%C3%A5thet,_onanering_og_orgasme.html"
        },
        {
          "title": "Er du lei av å onanere?",
          "text": "Mange skriver til ung.no og mener de onanerer for mye eller synes onaneringen har blitt kjedelig. Her er tipsene.",
          "navigateTo": "https://www.ung.no/sann-kan-du-lage-ditt-eget-sexleketoy"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/onanering"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/Jeg_blir_ikke_kat",
      "title": "Jeg blir ikke kåt",
      "subtitle": null,
      "ingress1": "Det er helt vanlig å ikke bli opphisset hver gang du får lyst til å onanere.",
      "ingress2": "Du kan føle seg kåt i både hodet og i kroppen. Ha seksuelle tanker eller fantasier, og det kan kile og krible i kroppen. Særlig i kjønnsorganene. Det å føle seg kåt betyr ikke alltid at penis blir stiv eller at man blir våt. Noen ganger kan du være for trøtt eller for sliten i kroppen, selv om hodet har lyst. Eller du  kan være  stresset for noe eller er redd for at noen skal oppdage hva du  driver med. \n\n Noen ganger kan man ha lyst til å onanere uten å være kåt, og andre ganger kan man være kåt uten å ha lyst til å onanere. Det er helt normalt. Det beste er å spare onanien til du både har lyst og føler deg kåt. \n\n Andre tips kan være å lage en helt ny fantasi. Eller du kan prøve å ta på deg selv på en helt ny måte. Det kan for eksempel være å ta på deg selv på andre steder enn på kjønnsorganet.",
      "resources": [
        {
          "title": "Kåthet, onanering og orgasme",
          "text": "I puberteten øker mengden hormoner som gir seksuell. Når kåtheten øker, er det naturlig at nysgjerrigheten på sex også øker.",
          "navigateTo": "https://www.ung.no/Sex/4136_K%C3%A5thet,_onanering_og_orgasme.html"
        },
        {
          "title": "Er du lei av å onanere?",
          "text": "Mange skriver til ung.no og mener de onanerer for mye eller synes onaneringen har blitt kjedelig. Her er tipsene.",
          "navigateTo": "https://www.ung.no/sann-kan-du-lage-ditt-eget-sexleketoy"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/onanering"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvorfor_far_jeg_vondt_nar_jeg_onanerer",
      "title": "Hvorfor får jeg vondt når jeg onanerer?",
      "subtitle": null,
      "ingress1": "Det kan være en medisinsk grunn til at det gjør vondt eller det kan være måten du gjør det på som gir smerter...",
      "ingress2": "Noen ganger får man vondt uten at man vet hvorfor. Ofte går det over av seg selv. Hvis det er like vondt etter noen dager er det lurt å gå til legen. \n\n Noen seksuelt overførbare infeksjoner (SOI) kan gjøre at kjønnsorganet svir eller gjør vondt når du tisser eller onanerer. Hvis det er vondt i penis kan det hende at forhuden er for trang. Da kan ikke forhuden trekkes tilbake fra penishodet eller det er vondt når du gjør det. Noen er redde for at det å ha en skjev penis skal være grunnen til smerter. Snakk med en voksen eller helsesykepleieren på skolen din, så kan du få hjelp hvis du trenger det. \n\n De fleste bruker hånden når de onanerer, men mange bruker også ulike gjenstander. Pass på at det du bruker ikke er spisst, skarpt, veldig hardt, eller laget av materiale som kan irritere huden eller slimhinnene. Du kan prøve å ta et kondom utenpå, rengjøre den bedre eller prøve noe helt annet. Smerter kan også skyldes at du har onanert på en hardhendt måte.",
      "resources": [
        {
          "title": "Kåthet, onanering og orgasme",
          "text": "I puberteten øker mengden hormoner som gir seksuell. Når kåtheten øker, er det naturlig at nysgjerrigheten på sex også øker.",
          "navigateTo": "https://www.ung.no/Sex/4136_K%C3%A5thet,_onanering_og_orgasme.html"
        },
        {
          "title": "Er du lei av å onanere?",
          "text": "Mange skriver til ung.no og mener de onanerer for mye eller synes onaneringen har blitt kjedelig. Her er tipsene.",
          "navigateTo": "https://www.ung.no/sann-kan-du-lage-ditt-eget-sexleketoy"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/onanering"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/kulturen_eller_religionen_min_advarer_meg_mot_a_onanere_hva_skal_jeg_gjore",
      "title": "Kulturen eller religionen min advarer meg mot å onanere. Hva skal jeg gjøre?",
      "subtitle": null,
      "ingress1": "Det kan være vanskelig når kulturen eller religionen du har forteller deg én ting  og kroppen vil noe helt annet.",
      "ingress2": "Noen sier at onani er en synd mot Gud, og at man bare skal ha sex med den man er gift med. Andre mener at det å onanere bryter med ære, og kaster skam over foreldrene, familien og slekten. Kanskje du har hørt noen si at onani er skittent eller urent, og at man kan bli syk av det? \n Da kan det å onanere gjøre at man får skyldfølelse, skammer seg, eller blir redd. \n\n Ingen trenger å føle seg skamfull eller uren for å ha naturlige tanker og følelser. \n\n Det er en myte at du kan bruke opp sæden eller bli mindre fruktbar av å onanere. \n\n Det finnes ingen medisinske grunner til å ikke onanere, flere studier viser til og med at det er sunt for kroppen å onanere. \n\n Lurer du på om du skal onanere? Her er fem positive ting som kan skje med kroppen når du onanerer: \n\n\u2022 Onanering kan hjelpe deg med å slappe av og kan gjøre det lettere å sovne om kvelden. \n\u2022 Onanering frigjør lykkehormoner som hjelper mot både angst og depresjon. \n\u2022 Mange jenter bruker onanering som smertestillende når de har mensen \n\u2022 Gutter og menn som onanerer har mindre sjanse for å få noen typer kreft. \n\n Nesten alle unge onanerer. Det er du som bestemmer om du skal onanere eller ikke.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/onanering"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvor_kan_jeg_onanere",
      "title": "Hvor kan jeg onanere?",
      "subtitle": null,
      "ingress1": "Du kan onanere når du er alene, for eksempel på rommet ditt eller i dusjen hjemme.",
      "ingress2": "Det er forbudt å onanere på offentlige steder eller på steder der andre kan se deg, uten at de ønsker det selv. For eksempel å stå i soveromsvinduet ditt og onanere, så forbipasserende kan se deg utenfra. Du kan heller ikke onanere foran noen som ikke har eller kan samtykke til det. Selv om det er kjæresten din eller en god venn eller venninne. \n\n Det å med vilje onanere foran noen som allerede er der eller som kan komme kalles for blotting og er forbudt. Før du kan onanere foran eller sammen med andre, må du få samtykke.",
      "resources": [
        {
          "title": "Er det lov å sende nudes eller dickpics?",
          "text": "Det kan være spennende å sende slike bilder, men i mange tilfeller kan det være straffbart. Her er det du trenger å vite om deling av nakenbilder.",
          "navigateTo": "https://www.ung.no/nettvett/4272_Er_det_lov_%C3%A5_sende_nudes_eller_dickpics.html"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/onanering"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/er_det_ok_for_jenter_a_onanere",
      "title": "Er det ok for jenter å onanere?",
      "subtitle": null,
      "ingress1": "Ja.",
      "ingress2": "Du kan onanere uansett kjønn, alder og seksuell orientering. Alle kan onanere, om de vil det selv og så ofte de vil. \n\n Gutter onanerer vanligvis oftere enn jenter, og unge gutter onanerer vanligvis oftere enn voksne menn. Gutter onanerer vanligvis like ofte enten de er single eller i forhold. Jenter onanerer vanligvis oftere når de er single. \n\n Det som er vanlig for de fleste gjelder ikke for alle. Mange jenter onanerer like mye eller mer enn gutter, og mange jenter onanerer like mye uansett om de er i forhold eller er single.",
      "resources": [
        {
          "title": "Er det lov å sende nudes eller dickpics?",
          "text": "Det kan være spennende å sende slike bilder, men i mange tilfeller kan det være straffbart. Her er det du trenger å vite om deling av nakenbilder.",
          "navigateTo": "https://www.ung.no/nettvett/4272_Er_det_lov_%C3%A5_sende_nudes_eller_dickpics.html"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/onanering"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/blir_jeg_kat_pa_feil_ting",
      "title": "Blir jeg kåt på feil ting?",
      "subtitle": null,
      "ingress1": "Ingen tanker er ulovlige, men noen tanker kan være plagsomme for deg.",
      "ingress2": "Det er vanlig å synes at det man blir kåt av er litt flaut, uansett hvem eller hva man blir kåt av. \n\n De fleste blir kåte av å tenke på en de er forelsket i eller liker veldig godt. Eller av å fantasere om seksuelle handlinger de synes er spennende og deilige. \n\n Noen blir kåte på andre, kanskje litt uvanlige ting, som føtter, kosedyr, undertøy eller andre ting. Eller på å gjøre ting med seg selv eller andre som kanskje gjør litt vondt, som å daske på rumpa eller holde hardt i håret. Sånne fantasier er helt ufarlige. \n\n Det er heller ikke helt uvanlig å bli kåt på noe som er forbudt å gjøre i virkeligheten. Som å blotte seg eller sende nakenbilder til noen som ikke har gitt samtykke til det, ha sex med noen som sover, eller tvinge noen til å ha sex. \n\n Hvis tankene gjør deg redd eller plager deg på noen måte, kan det være lurt å fortelle om fantasiene til noen. Det kan for eksempel være helsesykepleier på skolen, fastlegen din, helsesykepleier eller lege på helsestasjon for ungdom eller en annen voksen du stoler på. \n\n Fantasi og virkelighet er to forskjellige ting. Det at du fantaserer om noe betyr ikke det samme som at du kommer til å gjøre det i virkeligheten.",
      "resources": [
        {
          "title": "Hva betyr det å være pedo?",
          "text": "Visste du at barn og ungdommer ikke kan være pedo?",
          "navigateTo": "https://www.ung.no/hva-betyr-det-a-vaere-pedo"
        },
        {
          "title": "Er du i puberteten og tenker mye på sex?",
          "text": "Det er vanlig å ha sextanker, og er ikke noe å skamme seg over. Bli kjent med fantasiene dine. Er du veldig kåt, kan det hjelpe å onanere.",
          "navigateTo": "https://www.ung.no/kropp/pubertet/4344_Er_du_i_puberteten_og_tenker_mye_p%C3%A5_sex.html"
        },
        {
          "title": "Har du rare sextanker?",
          "text": "Det å få bilder i hodet når du onanerer eller mens du har sex, er normalt. Men noen sextanker kan være uheldige for deg. Og det er en del seksuelle ting som kan skade deg selv eller andre.",
          "navigateTo": "https://www.ung.no/har-du-rare-sextanker"
        },
        {
          "title": "Er det lov å ha sex med dyr?",
          "text": "Noen ganger får vi i ung.no spørsmål fra unge som enten blir kåte av tanken på dyr eller som forteller at de allerede har hatt sex med dyr.",
          "navigateTo": "https://www.ung.no/er-det-lov-a-ha-sex-med-dyr"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/onanering"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_kan_jeg_gjore_hvis_jeg_vil_slutte_a_bli_kat_pa_noe",
      "title": "Hva kan jeg gjøre hvis jeg vil slutte å bli kåt på noe?",
      "subtitle": null,
      "ingress1": "Prøv å styr tankene dine over på andre fantasier neste gang du onanerer.",
      "ingress2": "Er det noe annet og mer ufarlig som du også liker? Husker du hva du pleide å bli kåt av før? Du kan også prøve deg frem med å tenke på noe helt nytt eller annerledes. \n\n Du kan også prøve å tømme hodet og ikke fantasere i det hele tatt. Heller bare kjenne på hvordan det føles i kroppen, uten å tenke.",
      "resources": [
        {
          "title": "Hva betyr det å være pedo?",
          "text": "Visste du at barn og ungdommer ikke kan være pedo?",
          "navigateTo": "https://www.ung.no/hva-betyr-det-a-vaere-pedo"
        },
        {
          "title": "Tips for å endre uvaner eller slutte med noe",
          "text": "Ønsker du å slutte med noe, starte med noe eller forandre på noe? Vi gir deg råd for en varig endring, så det ikke bare blir med tanken.",
          "navigateTo": "https://www.ung.no/psykisk/4213_Tips_for_%C3%A5_endre_uvaner_eller_slutte_med_noe.html"
        },
        {
          "title": "Er du i puberteten og tenker mye på sex?",
          "text": "Det er vanlig å ha sextanker, og er ikke noe å skamme seg over. Bli kjent med fantasiene dine. Er du veldig kåt, kan det hjelpe å onanere.",
          "navigateTo": "https://www.ung.no/kropp/pubertet/4344_Er_du_i_puberteten_og_tenker_mye_p%C3%A5_sex.html"
        },
        {
          "title": "Har du rare sextanker?",
          "text": "Det å få bilder i hodet når du onanerer eller mens du har sex, er normalt. Men noen sextanker kan være uheldige for deg. Og det er en del seksuelle ting som kan skade deg selv eller andre.",
          "navigateTo": "https://www.ung.no/har-du-rare-sextanker"
        },
        {
          "title": "Er det lov å ha sex med dyr?",
          "text": "Noen ganger får vi i ung.no spørsmål fra unge som enten blir kåte av tanken på dyr eller som forteller at de allerede har hatt sex med dyr.",
          "navigateTo": "https://www.ung.no/er-det-lov-a-ha-sex-med-dyr"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/onanering"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/er_det_lov_a_tenke_pa_barn_mens_jeg_onanerer",
      "title": "Er det lov å tenke på barn mens jeg onanerer",
      "subtitle": null,
      "ingress1": "Ingen tanker er ulovlige,men noen tanker kan være uheldige for deg.",
      "ingress2": "Tenker du på sex med barn som er flere år yngre enn deg? Det er ikke ulovlig å ha sånne tanker. Det betyr heller ikke at du kommer til å gjøre det du tenker på i virkeligheten. \n\n Tanker og fantasier kan ikke skade andre, men de kan være uheldige for deg hvis de tar mye plass eller gjør deg bekymret. Seksuelle tanker og fantasier som får for mye plass, kan bli sterkere og gjøre at skillet mellom fantasier og virkelighet blir visket ut. For noen kan det gjøre at de skader noen i fremtiden \n\n Vil du finne ut mer om tankene dine, helt anonymt? Trykk på “Sjekk ut” nedenfor.",
      "resources": [
        {
          "title": "Er jeg en overgriper eller risikerer jeg å bli det?",
          "text": "Har du ofte tanker om å gjøre noe seksuelt med andre mot deres vilje, eller med en som er mye yngre enn deg? Eller har du allerede utnyttet noen seksuelt?",
          "navigateTo": "https://www.ung.no/har-du-utsatt-noen-for-overgrep"
        }
      ],
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/onanering"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/noen_har_vist_meg_porno",
      "title": "Noen har vist meg porno",
      "subtitle": null,
      "ingress1": "Det er bare du som skal bestemme om du vil se på porno eller ikke.",
      "ingress2": "Det er ulovlig å vise porno til noen som er under 18 år. Det er også ulovlig å vise porno til noen som ikke har samtykket. \n\n Det er vanlig å ha flere følelser når man ser porno første gang. Kanskje syntes du det var spennende, litt ekkelt og rart samtidig? \n\n Du kan oppleve at bildene fra pornoen kommer opp i hodet når du er kåt eller onanerer, selv om du ikke alltid liker det. \n\n Har noen vist deg porno uten at du ville det? Hvis det skjer igjen er det viktig at du tør å si nei. Eller sier fra til en voksen du kan stole på. \n\n Noen type porno er ulovlig å lage, se eller ha, men du trenger ikke å bekymre deg for å bli straffet dersom noen har vist deg porno.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Sett dine egne grenser og respekter andres",
          "text": "Alle mennesker har grenser. For at vi skal ha det bra og føle oss trygge, må disse grensene respekteres.",
          "navigateTo": "https://www.ung.no/overgrep/3656_Sett_dine_egne_grenser.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/noen_har_vist_meg_porno",
      "title": "Noen har vist meg porno",
      "subtitle": null,
      "ingress1": "Det er bare du som skal bestemme om du vil se på porno eller ikke.",
      "ingress2": "Det er ulovlig å vise porno til noen som er under 18 år. Det er også ulovlig å vise porno til noen som ikke har samtykket. \n\n Det er vanlig å ha flere følelser når man ser porno første gang. Kanskje syntes du det var spennende, litt ekkelt og rart samtidig? \n\n Du kan oppleve at bildene fra pornoen kommer opp i hodet når du er kåt eller onanerer, selv om du ikke alltid liker det. \n\n Har noen vist deg porno uten at du ville det? Hvis det skjer igjen er det viktig at du tør å si nei. Eller sier fra til en voksen du kan stole på. \n\n Noen type porno er ulovlig å lage, se eller ha, men du trenger ikke å bekymre deg for å bli straffet dersom noen har vist deg porno.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Sett dine egne grenser og respekter andres",
          "text": "Alle mennesker har grenser. For at vi skal ha det bra og føle oss trygge, må disse grensene respekteres.",
          "navigateTo": "https://www.ung.no/overgrep/3656_Sett_dine_egne_grenser.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_er_lov_a_se_pa",
      "title": "Hva er lov å se på?",
      "subtitle": null,
      "ingress1": "Du kan ikke bli straffet for å se på porno som viser sex mellom voksne, så lenge du ikke ser ulovlig porno.",
      "ingress2": "Ulovlig porno er video, bilder eller streaming som viser barn, dyr, lik, vold, tvang eller overgrep. \n\n Selv om det er vanlig at ungdom ser på porno, kan det bli et problem for noen. De som ser mye på porno kan synes det er vanskelig å bli kåte uten å se på porno. Andre de blir så opptatte av porno at de ikke får gjort ting som er viktige for dem. \n\n Det å vise porno til en som er under 18 år, som ikke samtykker til det eller som er mye yngre enn deg, kan være straffbart. \n Det å se på eller vise andre ulovlig porno er straffbart, uansett hvor gammel du er.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvorfor_er_det_aldersgrense_pa_porno",
      "title": "Hvorfor er det aldersgrense på porno?",
      "subtitle": null,
      "ingress1": "Porno kan påvirke tankene dine om kropp og sex på en negativ måte. Likevel er det ingen aldersgrense for å se porno, selv om det ikke er anbefalt å se det før man er 18. Det å vise porno til en som ikke samtykker eller som er mye yngre enn deg kan være straffbart.",
      "ingress2": "Grunnen til at det ikke er anbefalt, er at vi lærer av alt vi ser, hører, leser og opplever. Når du er ung lærer du mye nytt og du lærer fort. Veldig mange ser porno lenge før de begynner å ha sex med andre. Da kan de tro at sex skal være som det man har sett på bilder eller film. Mange jenter og gutter opplever at de tråkker over egne og andres grenser når de prøver å ha sex som de har sett i porno. \n\n Porno kan gi deg et feil bilde av hva sex egentlig er, og hvordan vanlige kropper ser ut. Mye av pornoen viser sex som egentlig er både uvanlig og ubehagelig i virkeligheten. Porno er skuespill, selv om det kan se ekte ut.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/jeg_ser_pa_porno_som_viser_sex_med_noen_som_er_i_stefamilie_med_hverandre",
      "title": "Jeg ser på porno som viser sex med noen som er i stefamilie med hverandre",
      "subtitle": null,
      "ingress1": "Det er ikke  ulovlig å se på porno som viser sex mellom voksne stesøsken, eller mellom stebarn og steforeldre",
      "ingress2": "Dette er en ganske vanlig form for porno, men ikke vanlig i virkeligheten. For noen er denne type porno noe de blir kåte av, uten at de har fantasier om sin egen familie. \n\n Det er ikke lov å ha sex med egne barn selv om det , selv om det ikke er biologiske bånd mellom dere. For eksempel stebarn og adoptivbarn.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Intimitet eller sex med noen i familien?",
          "text": "På ung.no får vi spørsmål om hva som er greit og ikke greit av nærhet og berøring. Også når det gjelder søsken og andre i familien.",
          "navigateTo": "https://www.ung.no/overgrep/3419_Intimitet_eller_sex_med_noen_i_familien.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvordan_kan_porno_pavirke_meg",
      "title": "Hvordan kan porno påvirke meg?",
      "subtitle": null,
      "ingress1": "Porno kan påvirke hvordan du tenker at sex skal se ut, hva du syns om kroppen din og hva du tenker om andres kropp. Det kan påvirke hva du blir kåt på, hva du syns at du selv burde få til og hva gutter og jenter liker når de har sex.",
      "ingress2": "Porno viser sex på en overdreven måte. I heterofil porno er mennene ofte maskuline og voldsomme. Kvinnene sier aldri nei og ser ut til å like alt mennene gjør. Porno kan påvirke deg til å tro at det er slik gutter burde oppføre seg og at det slik jenter vil ha det. \n\n I porno som viser homofile menn er det ofte en svak og en sterk part, på samme måte som i heterofil porno. Filmer som viser to jenter er ofte laget ut ifra heterofile menn sin fantasi, i stedet for å vise hvordan to jenter vanligvis har sex. \n\n Det også kan bli et problem at man blir så vant med porno at man sliter med å bli kåt uten. \n\n Når man har sex i virkeligheten er det viktig å bruke tid på å gjøre hverandre kåte, hvis ikke kan det gjøre vondt. \n\n Noen bruker porno for å bli kjent med sin egen seksualitet. Det finnes også porno for dem som tenner på mer uvanlige ting og for mange kan porno gjøre at de føler seg mindre alene.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_er_hentai_animeporno",
      "title": "Hva er hentai - animeporno?",
      "subtitle": null,
      "ingress1": "Hentai kalles også animeporno eller tegneserieporno.",
      "ingress2": "Det er de samme lovene som gjelder for hentai som for vanlig porno. \n\n Det er lov å se hentai når karakterene ser ut som voksne. \n\n Hentai er ulovlig når karakterene ser ut som mindreårige eller barn. Eller når den viser sex med dyr, lik, voldelig sex og drap.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/ser_jeg_for_mye_porno",
      "title": "Ser jeg for mye porno?",
      "subtitle": null,
      "ingress1": "Hvis du ser så mye porno at du ikke orker å gjøre andre ting, ikke klarer å la være eller ikke klarer å bli kåt uten, kan det være du ser for mye på porno.",
      "ingress2": "Det finnes ikke en klar grense for hvor mange timer med porno som er innafor. Likevel finnes det noen tegn som kan tyde på at det begynner å bli for mye. \n\n Hvis du ikke får tid til venner, skole eller fritid fordi du bruker all tiden din til å se porno, ser du nok for mye. \n\n Hvis du må se porno for å klare å bli kåt, for å slappe av, ha det bra eller sovne bør du også prøve å se mindre porno.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Kan det være feil å onanere?",
          "text": "Onanerer du mye til porno, så mye at du ikke får nok tid til å gjøre andre ting? Eller onanerer du på en måte som andre reagerer negativt på?",
          "navigateTo": "https://www.ung.no/kan-det-vaere-feil-a-onanere"
        },
        {
          "title": "Hvordan slutte med noe",
          "text": "Ønsker du å slutte med noe, starte med noe eller forandre på noe? Vi gir deg råd for en varig endring, så det ikke bare blir med tanken.",
          "navigateTo": "https://www.ung.no/psykisk/4213_Tips_for_%C3%A5_endre_uvaner_eller_slutte_med_noe.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/kan_man_bli_avhengig_av_porno",
      "title": "Kan man bli avhengig av porno?",
      "subtitle": null,
      "ingress1": "Det fins det ikke et klart svar på. Men det går an å føle seg avhengig av porno.",
      "ingress2": "Hvis du ofte føler at du må se mer og mer, blir urolig hvis du ikke får se det eller velger bort å gjøre ting med vennene dine eller kjæresten din fordi du heller vil se på porno, kan det ha blitt en uvane som det er vanskelig å slutte med.  Det samme gjelder hvis du ikke klarer å bli kåt uten å se på porno.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Kan det være feil å onanere?",
          "text": "Onanerer du mye til porno, så mye at du ikke får nok tid til å gjøre andre ting? Eller onanerer du på en måte som andre reagerer negativt på?",
          "navigateTo": "https://www.ung.no/kan-det-vaere-feil-a-onanere"
        },
        {
          "title": "Hvordan slutte med noe",
          "text": "Ønsker du å slutte med noe, starte med noe eller forandre på noe? Vi gir deg råd for en varig endring, så det ikke bare blir med tanken.",
          "navigateTo": "https://www.ung.no/psykisk/4213_Tips_for_%C3%A5_endre_uvaner_eller_slutte_med_noe.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/jeg_trenger_porno_for_a_bli_kat",
      "title": "Jeg trenger porno for å bli kåt",
      "subtitle": null,
      "ingress1": "Hvis du ikke klarer å bli kåt uten porno, kan det være lurt å trappe ned bruken eller ta en pause.",
      "ingress2": "Pausen kan du bruke til å trene opp dine egne fantasier sånn at du klarer å bli kåt også uten porno. \n\n For mange går det an å finne en sunn balanse. Da kan man se på porno av og til og samtidig ha et godt forhold til egen kropp og fantasier.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Kan det være feil å onanere?",
          "text": "Onanerer du mye til porno, så mye at du ikke får nok tid til å gjøre andre ting? Eller onanerer du på en måte som andre reagerer negativt på?",
          "navigateTo": "https://www.ung.no/kan-det-vaere-feil-a-onanere"
        },
        {
          "title": "Hvordan slutte med noe",
          "text": "Ønsker du å slutte med noe, starte med noe eller forandre på noe? Vi gir deg råd for en varig endring, så det ikke bare blir med tanken.",
          "navigateTo": "https://www.ung.no/psykisk/4213_Tips_for_%C3%A5_endre_uvaner_eller_slutte_med_noe.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/kjeresten_min_liker_ikke_at_jeg_ser_pa_porno",
      "title": "Kjæresten min liker ikke at jeg ser på porno",
      "subtitle": null,
      "ingress1": "Å være sammen med en som ser mye på porno kan føles ut som om det er «tredje» person i forholdet. Pornoen kan ta oppmerksomheten og tiden man som kjæreste ellers ville fått.",
      "ingress2": "Det kan føre til at kjæresten føler seg avvist, ikke god nok eller at det er en form for utroskap. \n\n Mange oppfatter porno som kvinneundertrykking og utnyttelse av mennesker. \n\n Hvis kjæresten din har det på denne måten er det først og fremst viktig at dere snakker sammen. Klarer dere å komme frem til en avtale som begge er fornøyde med?",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/jeg_bruker_porno_for_a_lere_om_sex",
      "title": "Jeg bruker porno for å lære om sex",
      "subtitle": null,
      "ingress1": "Du blir ikke automatisk god i senga av å se på porno.",
      "ingress2": "Det er fordi porno er laget for å fange seerens interesse, ikke for at skuespillerne skal ha det godt. \n\n Skuespillerne som er mindre og svakere blir ofte utsatt for ting som i virkeligheten kan gjøre vondt. \n\n Mange jenter liker å se på porno, selv om det kanskje ikke ville vært deilig å gjøre det de ser på i virkeligheten. \n\n Snakk med den du skal ha sex med før du prøver ut noe du har sett på porno. \n Prøv dere forsiktig frem og ikke føl deg mislykket hvis det ikke fungerer. \n\n Vil du lære mer om sex? På ung.no finnes det mange artikler om dette temaet.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/gutter_kan_trakassere_nar_de_gamer",
      "title": "Gutter kan trakassere når de gamer",
      "subtitle": null,
      "ingress1": "Mange jenter opplever seksuell trakassering og nedsettende kommentarer når de gamer.",
      "ingress2": "Det er ubehagelig å få negative eller seksuelle kommentarer fordi man er jente. Noen opplever så mye trakassering at de utgir seg for å være gutt eller skrur av mikrofonen. \n Dersom du er jente og opplever dette kan du prøve å finne andre jenter som gamer. \n Kanskje dere kan starte et lag med flere jenter?",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Sett dine egne grenser og respekter andres",
          "text": "Alle mennesker har grenser. For at vi skal ha det bra og føle oss trygge, må disse grensene respekteres.",
          "navigateTo": "https://www.ung.no/overgrep/3656_Sett_dine_egne_grenser.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/porno_og_gaming"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_betyr_det_a_vere_pedo",
      "title": "Hva betyr det å være pedo?",
      "subtitle": null,
      "ingress1": "Pedofili er å tenne seksuelt bare eller for det meste på barn som ikke har kommet i puberteten ennå eller som nettopp har kommet i puberteten.",
      "ingress2": "Pedofili er en psykisk lidelse og en diagnose. Man kan ikke få diagnosen  før man er 18 år eller eldre.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Er jeg en overgriper eller risikerer jeg å bli det?",
          "text": "Har du ofte tanker om å gjøre noe seksuelt med andre mot deres vilje, eller med en som er mye yngre enn deg? Eller har du allerede utnyttet noen seksuelt?",
          "navigateTo": "https://www.ung.no/har-du-utsatt-noen-for-overgrep"
        },
        {
          "title": "Hva betyr det å være pedo?",
          "text": "Visste du at barn og ungdommer ikke kan være pedo?",
          "navigateTo": "https://www.ung.no/hva-betyr-det-a-vaere-pedo"
        },
        {
          "title": "Har du rare sextanker?",
          "text": "Det å få bilder i hodet når du onanerer eller mens du har sex, er normalt. Men noen sextanker kan være uheldige for deg. Og det er en del seksuelle ting som kan skade deg selv eller andre.",
          "navigateTo": "https://www.ung.no/har-du-rare-sextanker"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/pedofili"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/er_det_lov_a_ha_pedofili",
      "title": "Er det lov å ha pedofili?",
      "subtitle": null,
      "ingress1": "Ja, å ha seksuelle fantasier om barn er lov.",
      "ingress2": "Ingen tanker er forbudte. Det er når tankene fører til handling at det kan være straffbart. \n\n Det som er ulovlig er å se på bilder eller videoer som viser barn på en seksuell måte. Voksne som gjør noe seksuelt med barn bryter loven og kan bli dømt til fengsel.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Er jeg en overgriper eller risikerer jeg å bli det?",
          "text": "Har du ofte tanker om å gjøre noe seksuelt med andre mot deres vilje, eller med en som er mye yngre enn deg? Eller har du allerede utnyttet noen seksuelt?",
          "navigateTo": "https://www.ung.no/har-du-utsatt-noen-for-overgrep"
        },
        {
          "title": "Hva betyr det å være pedo?",
          "text": "Visste du at barn og ungdommer ikke kan være pedo?",
          "navigateTo": "https://www.ung.no/hva-betyr-det-a-vaere-pedo"
        },
        {
          "title": "Har du rare sextanker?",
          "text": "Det å få bilder i hodet når du onanerer eller mens du har sex, er normalt. Men noen sextanker kan være uheldige for deg. Og det er en del seksuelle ting som kan skade deg selv eller andre.",
          "navigateTo": "https://www.ung.no/har-du-rare-sextanker"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/pedofili"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/kan_de_som_har_pedofili_slutte_a_ha_det",
      "title": "Kan de som har pedofili slutte å ha det?",
      "subtitle": null,
      "ingress1": "Ja. Pedofili kan behandles.",
      "ingress2": "Det å forstå hvor tankene kommer fra kan hjelpe noen å slutte å ha seksuelle tanker om barn. \n\n Andre blir ikke kvitt tankene. Da må man i stedet lære å leve med fantasiene uten å gjøre dem til virkelighet. \n\n Voksne med pedofili kan få hjelp på detfinneshjelp.no.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Er jeg en overgriper eller risikerer jeg å bli det?",
          "text": "Har du ofte tanker om å gjøre noe seksuelt med andre mot deres vilje, eller med en som er mye yngre enn deg? Eller har du allerede utnyttet noen seksuelt?",
          "navigateTo": "https://www.ung.no/har-du-utsatt-noen-for-overgrep"
        },
        {
          "title": "Hva betyr det å være pedo?",
          "text": "Visste du at barn og ungdommer ikke kan være pedo?",
          "navigateTo": "https://www.ung.no/hva-betyr-det-a-vaere-pedo"
        },
        {
          "title": "Har du rare sextanker?",
          "text": "Det å få bilder i hodet når du onanerer eller mens du har sex, er normalt. Men noen sextanker kan være uheldige for deg. Og det er en del seksuelle ting som kan skade deg selv eller andre.",
          "navigateTo": "https://www.ung.no/har-du-rare-sextanker"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/pedofili"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hva_kan_jeg_gjore_hvis_jeg_tror_jeg_har_pedofili",
      "title": "Hva kan jeg gjøre hvis jeg tror jeg har pedofili?",
      "subtitle": null,
      "ingress1": "Hvis du har sexfantasier om barn som er flere år yngre enn deg, er det lurt å fortelle om tankene dine til en du stoler på.",
      "ingress2": "Hvis du har sextanker om barn når du selv er ungdom betyr ikke det at du er pedofil eller at du kommer til å bli det. Det er mange voksne som har hatt sextanker om yngre barn da de selv var ungdommer, men som ikke har det nå lenger. \n\n Noen få fortsetter å ha sextanker om barn når de blir voksne og kan få diagnosen pedofili etter at de fyller 18. Detfinneshjelp.no hjelper voksne som er bekymret for at de blir kåte av barn. \n\n Noen klarer å slutte å ha seksuelle tanker om barn ved å styre tankene over på andre typer sexfantasier når de onanerer. Eller de lærer seg måter å leve med de seksuelle tankene sånn at de ikke skader andre og klarer å leve et godt liv. \n\n Er du usikker eller bekymret over fantasiene dine? Det å dele hemmeligheten med en voksen du stoler på kan gjøre den lettere å bære på.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Er jeg en overgriper eller risikerer jeg å bli det?",
          "text": "Har du ofte tanker om å gjøre noe seksuelt med andre mot deres vilje, eller med en som er mye yngre enn deg? Eller har du allerede utnyttet noen seksuelt?",
          "navigateTo": "https://www.ung.no/har-du-utsatt-noen-for-overgrep"
        },
        {
          "title": "Hva betyr det å være pedo?",
          "text": "Visste du at barn og ungdommer ikke kan være pedo?",
          "navigateTo": "https://www.ung.no/hva-betyr-det-a-vaere-pedo"
        },
        {
          "title": "Har du rare sextanker?",
          "text": "Det å få bilder i hodet når du onanerer eller mens du har sex, er normalt. Men noen sextanker kan være uheldige for deg. Og det er en del seksuelle ting som kan skade deg selv eller andre.",
          "navigateTo": "https://www.ung.no/har-du-rare-sextanker"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/pedofili"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/er_det_lov_a_se_pa_tegneserier_med_seksualiserte_tegninger_av_barn",
      "title": "Er det lov å se på tegneserier med seksualiserte tegninger av barn?",
      "subtitle": null,
      "ingress1": "Det er forbudt å lage, oppbevare, videresende eller legge ut tegneserier som seksualiserer barn.",
      "ingress2": "Det gjelder også tekster eller historier som beskriver barn som har sex med seg selv eller andre barn, eller voksne som utfører seksuelle overgrep mot barn.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Har du rare sextanker?",
          "text": "Det å få bilder i hodet når du onanerer eller mens du har sex, er normalt. Men noen sextanker kan være uheldige for deg. Og det er en del seksuelle ting som kan skade deg selv eller andre.",
          "navigateTo": "https://www.ung.no/har-du-rare-sextanker"
        },
        {
          "title": "Bilder og film som seksualiserer barn",
          "text": "Bilder eller filmer som seksualiserer barn og viser seksuelle overgrep mot barn, er ulovlig.",
          "navigateTo": "https://www.ung.no/overgrep/351_Bilder_og_film_som_seksualiserer_barn.html"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/pedofili"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/hvorfor_er_det_ikke_lov_a_se_pa_videoer_eller_bilder_som_viser_sex_med_barn",
      "title": "Hvorfor er det ikke lov å se på videoer eller bilder som viser sex med barn?",
      "subtitle": null,
      "ingress1": "Fordi det skader barna.",
      "ingress2": "Videoene hadde ikke blitt laget hvis ingen ville se dem. Jo flere som ser en sånn video, jo flere videoer blir det også laget i fremtiden.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Har du rare sextanker?",
          "text": "Det å få bilder i hodet når du onanerer eller mens du har sex, er normalt. Men noen sextanker kan være uheldige for deg. Og det er en del seksuelle ting som kan skade deg selv eller andre.",
          "navigateTo": "https://www.ung.no/har-du-rare-sextanker"
        },
        {
          "title": "Bilder og film som seksualiserer barn",
          "text": "Bilder eller filmer som seksualiserer barn og viser seksuelle overgrep mot barn, er ulovlig.",
          "navigateTo": "https://www.ung.no/overgrep/351_Bilder_og_film_som_seksualiserer_barn.html"
        },
        {
          "title": "Hva betyr det å være pedo?",
          "text": "Visste du at barn og ungdommer ikke kan være pedo?",
          "navigateTo": "https://www.ung.no/hva-betyr-det-a-vaere-pedo"
        },
        {
          "title": "Har du rare sextanker?",
          "text": "Det å få bilder i hodet når du onanerer eller mens du har sex, er normalt. Men noen sextanker kan være uheldige for deg. Og det er en del seksuelle ting som kan skade deg selv eller andre.",
          "navigateTo": "https://www.ung.no/har-du-rare-sextanker"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/pedofili"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/temabeskrivelse/ma_jeg_snakke_med_noen_hvis_jeg_tror_at_jeg_har_pedofili",
      "title": "Må jeg snakke med noen hvis jeg tror at jeg har pedofili?",
      "subtitle": null,
      "ingress1": "Det å snakke med noen kan hjelpe deg med å få det bedre.",
      "ingress2": "Ingen kan tvinge deg til å si noe du ikke vil, men ofte føles det som en lettelse å dele vanskelige tanker med en du stoler på. \n\n Du kan dele litt av gangen eller du kan fortelle alt. Husk at det bare er voksne over 18 år som kan få diagnosen pedofili. Mange ungdommer vokser nemlig tankene av seg når de selv blir eldre.",
      "exit": [
        {
          "exitTitle": "Gjort noe som er utafor?",
          "exitIngress": "Er du usikker på dine seksuelle tanker eller adferd?"
        }
      ],
      "resources": [
        {
          "title": "Har du rare sextanker?",
          "text": "Det å få bilder i hodet når du onanerer eller mens du har sex, er normalt. Men noen sextanker kan være uheldige for deg. Og det er en del seksuelle ting som kan skade deg selv eller andre.",
          "navigateTo": "https://www.ung.no/har-du-rare-sextanker"
        },
        {
          "title": "Bilder og film som seksualiserer barn",
          "text": "Bilder eller filmer som seksualiserer barn og viser seksuelle overgrep mot barn, er ulovlig.",
          "navigateTo": "https://www.ung.no/overgrep/351_Bilder_og_film_som_seksualiserer_barn.html"
        },
        {
          "title": "Hva betyr det å være pedo?",
          "text": "Visste du at barn og ungdommer ikke kan være pedo?",
          "navigateTo": "https://www.ung.no/hva-betyr-det-a-vaere-pedo"
        },
        {
          "title": "Har du rare sextanker?",
          "text": "Det å få bilder i hodet når du onanerer eller mens du har sex, er normalt. Men noen sextanker kan være uheldige for deg. Og det er en del seksuelle ting som kan skade deg selv eller andre.",
          "navigateTo": "https://www.ung.no/har-du-rare-sextanker"
        }
      ],
      "navigationButtons": [
        {
          "text": "Et steg tilbake",
          "type": 2,
          "navigateTo": "/temavalg/pedofili"
        },
        { "text": "SJEKK UT HER", "type": 4, "navigateTo": "/quizinngang" }
      ]
    },
    {
      "urlPath": "/quizinngang",
      "title": "Her kan du finne ut av om du har seksuelle tanker eller adferd som er utafor. \n\n Du vil få noen spørsmål om dine seksuelle tanker, situasjoner og handlinger. Husk at du er ",
      "subtitle": "100% anonym",
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "text": "START       ",
          "navigateTo": "/quiztemavalg"
        }
      ]
    },
    {
      "urlPath": "/quiztemavalg",
      "title": "Her er noen situasjoner man kan være bekymret for. Velg det som passer best for deg",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "icon": "Ikke_vil",
          "text": "Sex med en som ikke vil",
          "navigateTo": "/quiz/en_som_ikke_vil"
        },
        {
          "id": 2,
          "icon": "Bilder_og_video",
          "text": "Nakenbilder eller videoer",
          "navigateTo": "/quiz/nakenbilder_eller_videoer"
        },
        {
          "id": 3,
          "icon": "Sover",
          "text": "Sex med noen som sover eller er ruset",
          "navigateTo": "/quiz/noen_som_sover_eller_er_ruset"
        },
        {
          "id": 4,
          "icon": "Sarbar",
          "text": "Sex med en som er sårbar eller mye yngre",
          "navigateTo": "/quiz/en_som_er_sarbar_eller_mye_yngre"
        },
        {
          "id": 5,
          "icon": "Familie",
          "text": "Sex med en i familien",
          "navigateTo": "/quiz/en_i_familie"
        },
        {
          "id": 6,
          "icon": "Dyr_dukke",
          "text": "Sex med noe annet",
          "navigateTo": "/quiz/et_dyr_eller_en_sexdukke"
        },
        {
          "id": 7,
          "icon": "Porno_og_gaming",
          "text": "Jeg vil heller lære mer",
          "navigateTo": "/temavalg"
        },
        {
          "id": 8,
          "icon": "Tanker_og_fantasier",
          "text": "Ingen situasjoner passer",
          "navigateTo": "https://forms.office.com/e/8BUApUg7f5?origin=lprLink"
        }
      ],
      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": "/quizinngang" }]
    },
    {
      "urlPath": "/quiz/en_som_ikke_vil",
      "type": 2,
      "title": "Hva handler det om?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "en som sier nei?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_ikke_vil"
        },
        {
          "id": 2,
          "type": 1,
          "text": "en som ikke vil, men som ikke tør å si nei?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_ikke_vil"
        },
        {
          "id": 3,
          "type": 1,
          "text": "kjæresten min eller en som pleier å ha lyst?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_ikke_vil"
        },
        {
          "id": 4,
          "type": 1,
          "text": "en som jeg vil hevne meg på?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_ikke_vil"
        },
        {
          "id": 5,
          "type": 1,
          "text": "en som kommer til å gjøre motstand?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_ikke_vil"
        }
      ],
      "extraChoices": [
        {
          "id": 6,
          "type": 1,
          "text": "vet ikke",
          "value": false,
          "navigateTo": "/quiz/er_du_bekymret"
        },
        {
          "id": 7,
          "type": 1,
          "text": "ingen av alternativene passer",
          "value": false,
          "navigateTo": "/quiz/er_du_bekymret"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/et_dyr_eller_en_sexdukke",
      "type": 2,
      "title": "Hva handler det om?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "et dyr?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_et_dyr_eller_en_sexdukke"
        },
        {
          "id": 2,
          "type": 1,
          "text": "en sexdukke som ser ut som et barn?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_et_dyr_eller_en_sexdukke"
        }
      ],
      "extraChoices": [
        {
          "id": 3,
          "type": 1,
          "text": "vet ikke",
          "value": false,
          "navigateTo": "/quiz/er_du_bekymret"
        },
        {
          "id": 4,
          "type": 1,
          "text": "ingen av alternativene passer",
          "value": false,
          "navigateTo": "/quiz/er_du_bekymret"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/en_i_familie",
      "type": 2,
      "title": "Hva handler det om?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "helsøsken eller adoptivsøsken?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_i_familie"
        },
        {
          "id": 2,
          "type": 1,
          "text": "halvsøsken, stesøsken eller fostersøsken?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_i_familie"
        },
        {
          "id": 3,
          "type": 1,
          "text": "foreldre, besteforeldre eller oldeforeldre?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_i_familie"
        },
        {
          "id": 4,
          "type": 1,
          "text": "steforeldre?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_i_familie"
        },
        {
          "id": 5,
          "type": 1,
          "text": "omsorgsperson eller verge?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_i_familie"
        },
        {
          "id": 6,
          "type": 1,
          "text": "adoptivforeldre?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_i_familie"
        }
      ],
      "extraChoices": [
        {
          "id": 7,
          "type": 1,
          "text": "vet ikke",
          "value": false,
          "navigateTo": "/quiz/er_du_bekymret"
        },
        {
          "id": 8,
          "type": 1,
          "text": "ingen av alternativene passer",
          "value": false,
          "navigateTo": "/quiz/er_du_bekymret"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/noen_som_sover_eller_er_ruset",
      "type": 2,
      "title": "Hva handler det om?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "en som sover?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_sover_eller_er_rusa"
        },
        {
          "id": 2,
          "type": 1,
          "text": "en som er rusa eller full?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_sover_eller_er_rusa"
        },
        {
          "id": 3,
          "type": 1,
          "text": "en som av andre grunner ikke kan gi samtykke?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_sover_eller_er_rusa"
        }
      ],
      "extraChoices": [
        {
          "id": 4,
          "type": 1,
          "text": "vet ikke",
          "value": false,
          "navigateTo": "/quiz/er_du_bekymret"
        },
        {
          "id": 5,
          "type": 1,
          "text": "ingen av alternativene passer",
          "value": false,
          "navigateTo": "/quiz/er_du_bekymret"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/en_som_er_sarbar_eller_mye_yngre",
      "type": 2,
      "title": "Hva handler det om?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "en som er mye yngre enn meg?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_er_sarbar_eller_mye_yngre"
        },
        {
          "id": 2,
          "type": 1,
          "text": "en som oppfører seg yngre enn andre på sin alder?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_er_sarbar_eller_mye_yngre"
        },
        {
          "id": 3,
          "type": 1,
          "text": "en som har det vanskelig eller er lei seg?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_er_sarbar_eller_mye_yngre"
        },
        {
          "id": 4,
          "type": 1,
          "text": "en som har en psykisk funksjonsnedsettelse?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_er_sarbar_eller_mye_yngre"
        },
        {
          "id": 5,
          "type": 1,
          "text": "en som har en sykdom eller skade som gjør at hen ikke kan samtykke?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_er_sarbar_eller_mye_yngre"
        },
        {
          "id": 6,
          "type": 1,
          "text": "en som burde være takknemlig for å ha sex med meg?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_er_sarbar_eller_mye_yngre"
        },
        {
          "id": 7,
          "type": 1,
          "text": "en baby?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_er_sarbar_eller_mye_yngre"
        },
        {
          "id": 8,
          "type": 1,
          "text": "en jeg kanskje kan utnytte av andre grunner?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_en_som_er_sarbar_eller_mye_yngre"
        }
      ],
      "extraChoices": [
        {
          "id": 9,
          "type": 1,
          "text": "vet ikke",
          "value": false,
          "navigateTo": "/quiz/er_du_bekymret"
        },
        {
          "id": 10,
          "type": 1,
          "text": "ingen av alternativene passer",
          "value": false,
          "navigateTo": "/quiz/er_du_bekymret"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/nakenbilder_eller_videoer",
      "type": 2,
      "title": "Hva handler det om?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "sende til en som ikke har bedt om det?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_nakenbilder_eller_videoer"
        },
        {
          "id": 2,
          "type": 1,
          "text": "dele av en som ikke vet at jeg har det?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_nakenbilder_eller_videoer"
        },
        {
          "id": 3,
          "type": 1,
          "text": "dele av en som ikke vil at jeg skal gjøre det?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_nakenbilder_eller_videoer"
        },
        {
          "id": 4,
          "type": 1,
          "text": "ta bilder eller filme uten at personen vet det?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_nakenbilder_eller_videoer"
        },
        {
          "id": 5,
          "type": 1,
          "text": "mase om nakenbilder?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_nakenbilder_eller_videoer"
        },
        {
          "id": 6,
          "type": 1,
          "text": "overtale noen til å gjøre seksuelle ting, som jeg filmer eller tar bilde av?",
          "value": false,
          "navigateTo": "/quiz/gjort_noe_nakenbilder_eller_videoer"
        }
      ],
      "extraChoices": [
        {
          "id": 7,
          "type": 1,
          "text": "vet ikke",
          "value": false,
          "navigateTo": "/quiz/er_du_bekymret"
        },
        {
          "id": 8,
          "type": 1,
          "text": "ingen av alternativene passer",
          "value": false,
          "navigateTo": "/quiz/er_du_bekymret"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/er_du_bekymret",
      "type": 2,
      "title": "Er du bekymret for noe du har gjort?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Ja",
          "value": false,
          "navigateTo": "/quiz/pavirkning"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Nei",
          "value": false,
          "navigateTo": "/quiz/plagsomme_tanker"
        },
        {
          "id": 3,
          "type": 1,
          "text": "Vet ikke",
          "value": false,
          "navigateTo": "/quiz/plagsomme_tanker"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/plagsomme_tanker",
      "title": "Har du plagsomme tanker du skulle ønske at kunne forsvinne?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Ja",
          "value": false,
          "navigateTo": "/quiz/pavirkning"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Nei",
          "value": false,
          "navigateTo": "/quiz/noen_a_snakke_med"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Vet ikke",
          "value": false,
          "navigateTo": "/quiz/noen_a_snakke_med"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/noen_a_snakke_med",
      "title": "Trenger du noen å snakke med?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Ja",
          "value": false,
          "navigateTo": "/quizsvar"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Nei",
          "value": false,
          "navigateTo": "/quizbeklager"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/pavirkning",
      "title": "Hvordan føles det for deg?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Det føles greit",
          "value": false,
          "responseLevel": 1,
          "responseType": 3,
          "navigateTo": "/quizsvar"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Det er litt vanskelig",
          "value": false,
          "responseLevel": 2,
          "responseType": 3,
          "navigateTo": "/quizsvar"
        },
        {
          "id": 3,
          "type": 1,
          "text": "Det er vanskelig, men går ikke ut over hverdagen min",
          "value": false,
          "responseLevel": 2,
          "responseType": 3,
          "navigateTo": "/quizsvar"
        },
        {
          "id": 4,
          "type": 1,
          "text": "Det er så vanskelig at det går ut over hverdagen min",
          "value": false,
          "responseLevel": 3,
          "responseType": 3,
          "navigateTo": "/quizsvar"
        }
      ],
      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/prosess_pavirkning",
      "title": "Hvordan føler du deg når du tenker på dette?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Det føles greit",
          "value": false,
          "responseLevel": 1,
          "responseType": 1,
          "navigateTo": "/quizsvar"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Det er litt vanskelig",
          "value": false,
          "responseLevel": 2,
          "responseType": 1,
          "navigateTo": "/quizsvar"
        },
        {
          "id": 3,
          "type": 1,
          "text": "Det er vanskelig, men går ikke ut over hverdagen min",
          "value": false,
          "responseLevel": 2,
          "responseType": 1,
          "navigateTo": "/quizsvar"
        },
        {
          "id": 4,
          "type": 1,
          "text": "Det er så vanskelig at det går ut over hverdagen min",
          "value": false,
          "responseLevel": 3,
          "responseType": 1,
          "navigateTo": "/quizsvar"
        },
        {
          "id": 5,
          "type": 1,
          "text": "Vet ikke",
          "value": false,
          "responseLevel": 2,
          "responseType": 1,
          "navigateTo": "/quizsvar"
        }
      ],
      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/prosess_pavirkning_planlegger",
      "title": "Hvordan føler du deg når du tenker på dette?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Det føles greit",
          "value": false,
          "responseLevel": 2,
          "responseType": 1,
          "navigateTo": "/quizsvar"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Det er litt vanskelig",
          "value": false,
          "responseLevel": 2,
          "responseType": 1,
          "navigateTo": "/quizsvar"
        },
        {
          "id": 3,
          "type": 1,
          "text": "Det er vanskelig, men går ikke ut over hverdagen min",
          "value": false,
          "responseLevel": 2,
          "responseType": 1,
          "navigateTo": "/quizsvar"
        },
        {
          "id": 4,
          "type": 1,
          "text": "Det er så vanskelig at det går ut over hverdagen min",
          "value": false,
          "responseLevel": 3,
          "responseType": 1,
          "navigateTo": "/quizsvar"
        },
        {
          "id": 5,
          "type": 1,
          "text": "Vet ikke",
          "value": false,
          "responseLevel": 2,
          "responseType": 1,
          "navigateTo": "/quizsvar"
        }
      ],
      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/gjort_noe_en_som_ikke_vil",
      "title": "Har du gjort noe seksuelt med en som ikke vil?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Ja, jeg har gjort det",
          "value": false,
          "responseLevel": 3,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Nei, men jeg planlegger å gjøre det",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_planlegger"
        },
        {
          "id": 3,
          "type": 1,
          "text": "Nei, men jeg fantaserer om å gjøre det",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_fantaserer"
        },
        {
          "id": 4,
          "type": 1,
          "text": "Nei",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_fantaserer"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/gjort_noe_en_i_familie",
      "title": "Har du gjort noe seksuelt med en i familien?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Ja, jeg har gjort det",
          "value": false,
          "responseLevel": 3,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Nei, men jeg planlegger å gjøre det",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_planlegger"
        },
        {
          "id": 3,
          "type": 1,
          "text": "Nei, men jeg fantaserer om å gjøre det",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_fantaserer"
        },
        {
          "id": 4,
          "type": 1,
          "text": "Nei",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_fantaserer"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/gjort_noe_et_dyr_eller_en_sexdukke",
      "title": "Handler det om at du har gjort noe seksuelt?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Ja, jeg har gjort det",
          "value": false,
          "responseLevel": 3,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Nei, men jeg planlegger å gjøre det",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_planlegger"
        },
        {
          "id": 3,
          "type": 1,
          "text": "Nei, men jeg fantaserer om å gjøre det",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_fantaserer"
        },
        {
          "id": 4,
          "type": 1,
          "text": "Nei",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_fantaserer"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/gjort_noe_en_som_sover_eller_er_rusa",
      "title": "Har du gjort noe seksuelt med en som sover eller er rusa?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Ja, jeg har gjort det",
          "value": false,
          "responseLevel": 3,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Nei, men jeg planlegger å gjøre det",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_planlegger"
        },
        {
          "id": 3,
          "type": 1,
          "text": "Nei, men jeg fantaserer om å gjøre det",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_fantaserer"
        },
        {
          "id": 4,
          "type": 1,
          "text": "Nei",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_fantaserer"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/gjort_noe_en_som_er_sarbar_eller_mye_yngre",
      "title": "Har du gjort noe seksuelt med en som er sårbar eller mye yngre?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Ja, jeg har gjort det",
          "value": false,
          "responseLevel": 3,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Nei, men jeg planlegger å gjøre det",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_planlegger"
        },
        {
          "id": 3,
          "type": 1,
          "text": "Nei, men jeg fantaserer om å gjøre det",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_fantaserer"
        },
        {
          "id": 4,
          "type": 1,
          "text": "Nei",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_fantaserer"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/gjort_noe_nakenbilder_eller_videoer",
      "title": "Har du sendt til en som ikke ba om det?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Ja, jeg har gjort det",
          "value": false,
          "responseLevel": 3,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Nei, men jeg planlegger å gjøre det",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_planlegger"
        },
        {
          "id": 3,
          "type": 1,
          "text": "Nei, men jeg fantaserer om å gjøre det",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_fantaserer"
        },
        {
          "id": 4,
          "type": 1,
          "text": "Nei",
          "value": false,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_forberedelser_fantaserer"
        }
      ],

      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/prosess_forberedelser_planlegger",
      "title": "Hva passer best?",
      "subtitle": "Husk at du er 100% anonym og at svarene dine ikke spores",
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Jeg tenker på hvordan jeg vil gjøre det",
          "value": false,
          "responseLevel": 3,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Jeg er i gang med å utføre noe",
          "value": false,
          "responseLevel": 3,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning"
        }
      ],
      "extraChoices": [
        {
          "id": 3,
          "type": 1,
          "text": "Vet ikke",
          "value": false,
          "responseLevel": 2,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning_planlegger"
        }
      ],
      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quiz/prosess_forberedelser_fantaserer",
      "title": "Tenker du at du kan komme til å gjøre det i fremtiden?",
      "subtitle": null,
      "ingress1": null,
      "ingress2": null,
      "choices": [
        {
          "id": 1,
          "type": 1,
          "text": "Ja",
          "value": false,
          "responseLevel": 2,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning"
        },
        {
          "id": 2,
          "type": 1,
          "text": "Nei",
          "value": false,
          "responseLevel": 1,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning"
        },
        {
          "id": 3,
          "type": 1,
          "text": "Kanskje",
          "value": false,
          "responseLevel": 2,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning"
        }
      ],
      "extraChoices": [
        {
          "id": 4,
          "type": 1,
          "text": "Vet ikke",
          "value": false,
          "responseLevel": 2,
          "responseType": 2,
          "navigateTo": "/quiz/prosess_pavirkning"
        }
      ],
      "navigationButtons": [{ "text": "Et steg tilbake", "type": 2, "navigateTo": null }]
    },
    {
      "urlPath": "/quizbeklager",
      "title": "Beklager at vi ikke kunne hjelpe deg...",
      "type": 1,
      "subtitle": null,
      "ingress1": null,
      "choices": null,
      "exit": [
        {
          "exitTitle": "Prøve på nytt?",
          "exitIngress": "Du kan gjerne sjekke ut igjen!"
        },
        {
          "exitTitle": "Vil du lære mer?",
          "exitIngress": "Hvis du vil utforske et eller flere av temaene våre, kan du trykke på knappen under for å komme til temaoversikten."
        }
      ],
      "navigationButtons": [
        { "text": "Et steg tilbake", "type": 2, "navigateTo": null },
        { "text": "SJEKK UT IGJEN", "type": 4, "navigateTo": "/quizinngang" },
        { "text": "LÆR MER", "type": 4, "navigateTo": "/temavalg" }
      ]
    },
    {
      "urlPath": "/quizsvar/noytral",
      "type": 1,
      "title": "Vi håper å kunne hjelpe deg litt videre...",
      "subtitle": " ",
      "ingress1": "Det er ofte godt å dele små og store bekymringer med en man stoler på.",
      "ingress2": "\nDet kan være godt å snakke med en du stoler på.",
      "toolIds": ["a68c3e61-a1cc-4a62-aff5-59b674559948", "a68c3e61-a1cc-4a62-aff5-59b674559948"],
      "exit": [
        {
          "exitTitle": "Prøve på nytt?",
          "exitIngress": "Du kan gjerne sjekke ut igjen!"
        },
        {
          "exitTitle": "Vil du lære mer?",
          "exitIngress": "Hvis du vil utforske et eller flere av temaene våre, kan du \ntrykke på knappen under for å komme til temaoversikten."
        }
      ],
      "navigationButtons": [
        { "text": "Et steg tilbake", "type": 2, "navigateTo": null },
        { "text": "SJEKK UT IGJEN", "type": 4, "navigateTo": "/quizinngang" },
        { "text": "LÆR MER", "type": 4, "navigateTo": "/temavalg" }
      ]
    },
    {
      "urlPath": "/quizsvar/en",
      "type": 1,
      "title": "Vi håper å kunne hjelpe deg litt videre...",
      "subtitle": " ",
      "ingress1": "Vi vet ikke nøyaktig hva du har i tankene, men ofte er det godt å dele både små og store bekymringer med en man stoler på.",
      "ingress2": "\nDet kan være godt å snakke med en du stoler på",
      "resources": [
        {
          "title": "Hva er samtykke til sex?",
          "text": "Å gi samtykke betyr å si ja, enten med ord eller med kroppsspråk. Du kan få samtykke til å kose, kysse, ta på, fingre, runke, ha sex eller andre ting.",
          "navigateTo": "https://www.ung.no/overgrep/3251_Hva_er_samtykke_til_sex.html"
        },
        {
          "title": "Kan jeg ha sex før jeg fyller 16 år?",
          "text": "Mange lurer på om det er ulovlig å ha sex hvis de selv, eller den de vil ha sex med, er under seksuell lavalder. Her forklarer vi regelverket for sex mellom ungdom.",
          "navigateTo": "https://www.ung.no/Sex/2422_Hva_er_seksuell_lavalder.html"
        }
      ],
      "toolIds": ["a68c3e61-a1cc-4a62-aff5-59b674559948", "a68c3e61-a1cc-4a62-aff5-59b674559948"],
      "exit": [
        {
          "exitTitle": "Prøve på nytt?",
          "exitIngress": "Du kan gjerne sjekke ut igjen!"
        },
        {
          "exitTitle": "Vil du lære mer?",
          "exitIngress": "Hvis du vil utforske et eller flere av temaene våre, kan du \ntrykke på knappen under for å komme til temaoversikten."
        }
      ],
      "navigationButtons": [
        { "text": "Et steg tilbake", "type": 2, "navigateTo": null },
        { "text": "SJEKK UT IGJEN", "type": 4, "navigateTo": "/quizinngang" },
        { "text": "LÆR MER", "type": 4, "navigateTo": "/temavalg" }
      ]
    },
    {
      "urlPath": "/quizsvar/to",
      "type": 1,
      "title": "Vi håper å kunne hjelpe deg litt videre...",
      "subtitle": " ",
      "ingress1": "Vi vet ikke nøyaktig hva du har i tankene. Det er vanlig å ha det vanskelig i perioder, men det er lurt å be om hjelp før det går for lang tid.",
      "ingress2": "\nDet vil være bra å snakke med en du stoler på",
      "resources": [
        {
          "title": "Hva er samtykke til sex?",
          "text": "Å gi samtykke betyr å si ja, enten med ord eller med kroppsspråk. Du kan få samtykke til å kose, kysse, ta på, fingre, runke, ha sex eller andre ting.",
          "navigateTo": "https://www.ung.no/overgrep/3251_Hva_er_samtykke_til_sex.html"
        },
        {
          "title": "Kan jeg ha sex før jeg fyller 16 år?",
          "text": "Mange lurer på om det er ulovlig å ha sex hvis de selv, eller den de vil ha sex med, er under seksuell lavalder. Her forklarer vi regelverket for sex mellom ungdom.",
          "navigateTo": "https://www.ung.no/Sex/2422_Hva_er_seksuell_lavalder.html"
        }
      ],
      "toolIds": ["a68c3e61-a1cc-4a62-aff5-59b674559948", "a68c3e61-a1cc-4a62-aff5-59b674559948"],
      "exit": [
        {
          "exitTitle": "Prøve på nytt?",
          "exitIngress": "Du kan gjerne sjekke ut igjen!"
        },
        {
          "exitTitle": "Vil du lære mer?",
          "exitIngress": "Hvis du vil utforske et eller flere av temaene våre, kan du \ntrykke på knappen under for å komme til temaoversikten."
        }
      ],
      "navigationButtons": [
        { "text": "Et steg tilbake", "type": 2, "navigateTo": null },
        { "text": "SJEKK UT IGJEN", "type": 4, "navigateTo": "/quizinngang" },
        { "text": "LÆR MER", "type": 4, "navigateTo": "/temavalg" }
      ]
    },
    {
      "urlPath": "/quizsvar/tre",
      "type": 1,
      "title": "Vi håper å kunne hjelpe deg litt videre...",
      "subtitle": " ",
      "ingress1": "Vi vet ikke nøyaktig hva du har i tankene, men det kan ikke være godt å ha det sånn.",
      "ingress2": "\nDet vil være bra for deg å snakke med noen",
      "resources": [
        {
          "title": "Hva er samtykke til sex?",
          "text": "Å gi samtykke betyr å si ja, enten med ord eller med kroppsspråk. Du kan få samtykke til å kose, kysse, ta på, fingre, runke, ha sex eller andre ting.",
          "navigateTo": "https://www.ung.no/overgrep/3251_Hva_er_samtykke_til_sex.html"
        },
        {
          "title": "Kan jeg ha sex før jeg fyller 16 år?",
          "text": "Mange lurer på om det er ulovlig å ha sex hvis de selv, eller den de vil ha sex med, er under seksuell lavalder. Her forklarer vi regelverket for sex mellom ungdom.",
          "navigateTo": "https://www.ung.no/Sex/2422_Hva_er_seksuell_lavalder.html"
        }
      ],
      "toolIds": ["a68c3e61-a1cc-4a62-aff5-59b674559948", "a68c3e61-a1cc-4a62-aff5-59b674559948"],
      "exit": [
        {
          "exitTitle": "Prøve på nytt?",
          "exitIngress": "Du kan gjerne sjekke ut igjen!"
        },
        {
          "exitTitle": "Vil du lære mer?",
          "exitIngress": "Hvis du vil utforske et eller flere av temaene våre, kan du \ntrykke på knappen under for å komme til temaoversikten."
        }
      ],
      "navigationButtons": [
        { "text": "Et steg tilbake", "type": 2, "navigateTo": null },
        { "text": "SJEKK UT IGJEN", "type": 4, "navigateTo": "/quizinngang" },
        { "text": "LÆR MER", "type": 4, "navigateTo": "/temavalg" }
      ]
    },
    {
      "urlPath": "/quizsvar/en_en",
      "type": 1,
      "title": "Dine resultater:",
      "subtitle": " ",
      "ingress1": "Du vet hva som er innafor og tar godt vare på andres seksuelle grenser. Stol på deg selv!",
      "ingress2": "Det finnes mange ulike sextanker og fantasier. Det er vanlig å ha seksuelle tanker og fantasier uten at man gjør dem til virkelighet. Fantasier kan komme og gå, og trenger ikke å bety noe for hvordan du er som person.\n\nFortsett sånn!",
      "resources": [
        {
          "title": "Hva er samtykke til sex?",
          "text": "Å gi samtykke betyr å si ja, enten med ord eller med kroppsspråk. Du kan få samtykke til å kose, kysse, ta på, fingre, runke, ha sex eller andre ting.",
          "navigateTo": "https://www.ung.no/overgrep/3251_Hva_er_samtykke_til_sex.html"
        },
        {
          "title": "Kan jeg ha sex før jeg fyller 16 år?",
          "text": "Mange lurer på om det er ulovlig å ha sex hvis de selv, eller den de vil ha sex med, er under seksuell lavalder. Her forklarer vi regelverket for sex mellom ungdom.",
          "navigateTo": "https://www.ung.no/Sex/2422_Hva_er_seksuell_lavalder.html"
        }
      ],
      "toolIds": ["a68c3e61-a1cc-4a62-aff5-59b674559948", "a68c3e61-a1cc-4a62-aff5-59b674559948"],
      "exit": [
        {
          "exitTitle": "Vil du lære mer?",
          "exitIngress": "Hvis du vil utforske et eller flere av temaene våre, kan du \ntrykke på knappen under for å komme til temaoversikten."
        }
      ],
      "navigationButtons": [
        { "text": "Et steg tilbake", "type": 2, "navigateTo": null },
        { "text": "LÆR MER", "type": 4, "navigateTo": "/temavalg" }
      ]
    },
    {
      "urlPath": "/quizsvar/en_to",
      "type": 1,
      "title": "Dine resultater:",
      "subtitle": " ",
      "ingress1": "Det er bra å være bevisst på hva som er innafor og utafor. Likevel kan det være vanskelig å forstå seksuelle grenser. Det kan man få hjelp til!",
      "ingress2": "Det å tråkke over andres grenser kan være skadelig. Det er vanlig å ha seksuelle tanker og fantasier uten at man gjør dem til virkelighet. Hvis tankene tar mye plass eller gjør en bekymret, kan det være lurt å be om hjelp.\n\nDet vil være bra å snakke med noen.",
      "resources": [
        {
          "title": "Hva er samtykke til sex?",
          "text": "Å gi samtykke betyr å si ja, enten med ord eller med kroppsspråk. Du kan få samtykke til å kose, kysse, ta på, fingre, runke, ha sex eller andre ting.",
          "navigateTo": "https://www.ung.no/overgrep/3251_Hva_er_samtykke_til_sex.html"
        },
        {
          "title": "Kan jeg ha sex før jeg fyller 16 år?",
          "text": "Mange lurer på om det er ulovlig å ha sex hvis de selv, eller den de vil ha sex med, er under seksuell lavalder. Her forklarer vi regelverket for sex mellom ungdom.",
          "navigateTo": "https://www.ung.no/Sex/2422_Hva_er_seksuell_lavalder.html"
        }
      ],
      "toolIds": ["a68c3e61-a1cc-4a62-aff5-59b674559948", "a68c3e61-a1cc-4a62-aff5-59b674559948"],
      "exit": [
        {
          "exitTitle": "Vil du lære mer?",
          "exitIngress": "Hvis du vil utforske et eller flere av temaene våre, kan du \ntrykke på knappen under for å komme til temaoversikten."
        }
      ],
      "navigationButtons": [
        { "text": "Et steg tilbake", "type": 2, "navigateTo": null },
        { "text": "LÆR MER", "type": 4, "navigateTo": "/temavalg" }
      ]
    },
    {
      "urlPath": "/quizsvar/to_to",
      "type": 1,
      "title": "Dine resultater:",
      "subtitle": " ",
      "ingress1": "Det kan være vanskelig å forstå seksuelle grenser. Det kan man få hjelp til! Mange får det lettere etter å ha delt tankene sine med en de stoler på.",
      "ingress2": "Det å tråkke over andres grenser kan være skadelig. Det at du har tatt denne testen er et godt steg i riktig retning for å lære hva som er innafor. Husk at det er vanlig å ha seksuelle tanker og fantasier uten at man gjør dem til virkelighet.\n\nDet vil være bra å snakke med noen.",
      "resources": [
        {
          "title": "Hva er samtykke til sex?",
          "text": "Å gi samtykke betyr å si ja, enten med ord eller med kroppsspråk. Du kan få samtykke til å kose, kysse, ta på, fingre, runke, ha sex eller andre ting.",
          "navigateTo": "https://www.ung.no/overgrep/3251_Hva_er_samtykke_til_sex.html"
        },
        {
          "title": "Kan jeg ha sex før jeg fyller 16 år?",
          "text": "Mange lurer på om det er ulovlig å ha sex hvis de selv, eller den de vil ha sex med, er under seksuell lavalder. Her forklarer vi regelverket for sex mellom ungdom.",
          "navigateTo": "https://www.ung.no/Sex/2422_Hva_er_seksuell_lavalder.html"
        }
      ],
      "toolIds": ["a68c3e61-a1cc-4a62-aff5-59b674559948", "a68c3e61-a1cc-4a62-aff5-59b674559948"],
      "exit": [
        {
          "exitTitle": "Vil du lære mer?",
          "exitIngress": "Hvis du vil utforske et eller flere av temaene våre, kan du \ntrykke på knappen under for å komme til temaoversikten."
        }
      ],
      "navigationButtons": [
        { "text": "Et steg tilbake", "type": 2, "navigateTo": null },
        { "text": "LÆR MER", "type": 4, "navigateTo": "/temavalg" }
      ]
    },
    {
      "urlPath": "/quizsvar/to_tre",
      "type": 1,
      "title": "Dine resultater:",
      "subtitle": " ",
      "ingress1": "Det kan se ut som du går over egne eller andres seksuelle grenser. Det kan være vanskelig å forstå seksuelle grenser. Det kan man få hjelp til! Mange får det lettere etter å ha delt tankene sine med en de stoler på.",
      "ingress2": "Det å tråkke over andres grenser kan være skadelig. Det at du har tatt denne testen er et godt steg i riktig retning for å lære hva som er innafor.\n\nDet er viktig å få hjelp. Du bør ta kontakt.",
      "resources": [
        {
          "title": "Hva er samtykke til sex?",
          "text": "Å gi samtykke betyr å si ja, enten med ord eller med kroppsspråk. Du kan få samtykke til å kose, kysse, ta på, fingre, runke, ha sex eller andre ting.",
          "navigateTo": "https://www.ung.no/overgrep/3251_Hva_er_samtykke_til_sex.html"
        },
        {
          "title": "Kan jeg ha sex før jeg fyller 16 år?",
          "text": "Mange lurer på om det er ulovlig å ha sex hvis de selv, eller den de vil ha sex med, er under seksuell lavalder. Her forklarer vi regelverket for sex mellom ungdom.",
          "navigateTo": "https://www.ung.no/Sex/2422_Hva_er_seksuell_lavalder.html"
        }
      ],
      "toolIds": ["a68c3e61-a1cc-4a62-aff5-59b674559948", "a68c3e61-a1cc-4a62-aff5-59b674559948"],
      "exit": [
        {
          "exitTitle": "Vil du lære mer?",
          "exitIngress": "Hvis du vil utforske et eller flere av temaene våre, kan du \ntrykke på knappen under for å komme til temaoversikten."
        }
      ],
      "navigationButtons": [
        { "text": "Et steg tilbake", "type": 2, "navigateTo": null },
        { "text": "LÆR MER", "type": 4, "navigateTo": "/temavalg" }
      ]
    },
    {
      "urlPath": "/quizsvar/en_tre",
      "type": 1,
      "title": "Dine resultater:",
      "subtitle": " ",
      "ingress1": "Det kan se ut som du går over egne eller andres seksuelle grenser. Det kan være vanskelig å forstå seksuelle grenser. Det kan man få hjelp til!",
      "ingress2": "Det å tråkke over andres grenser kan være skadelig. Det at du har tatt denne testen er et godt steg i riktig retning for å lære hva som er innafor.\n\nDet er viktig å få hjelp. Du bør ta kontakt.",
      "resources": [
        {
          "title": "Hva er samtykke til sex?",
          "text": "Å gi samtykke betyr å si ja, enten med ord eller med kroppsspråk. Du kan få samtykke til å kose, kysse, ta på, fingre, runke, ha sex eller andre ting.",
          "navigateTo": "https://www.ung.no/overgrep/3251_Hva_er_samtykke_til_sex.html"
        },
        {
          "title": "Kan jeg ha sex før jeg fyller 16 år?",
          "text": "Mange lurer på om det er ulovlig å ha sex hvis de selv, eller den de vil ha sex med, er under seksuell lavalder. Her forklarer vi regelverket for sex mellom ungdom.",
          "navigateTo": "https://www.ung.no/Sex/2422_Hva_er_seksuell_lavalder.html"
        }
      ],
      "toolIds": ["a68c3e61-a1cc-4a62-aff5-59b674559948", "a68c3e61-a1cc-4a62-aff5-59b674559948"],
      "exit": [
        {
          "exitTitle": "Vil du lære mer?",
          "exitIngress": "Hvis du vil utforske et eller flere av temaene våre, kan du \ntrykke på knappen under for å komme til temaoversikten."
        }
      ],
      "navigationButtons": [
        { "text": "Et steg tilbake", "type": 2, "navigateTo": null },
        { "text": "LÆR MER", "type": 4, "navigateTo": "/temavalg" }
      ]
    },
    {
      "urlPath": "/quizsvar/to_en",
      "type": 1,
      "title": "Dine resultater:",
      "subtitle": " ",
      "ingress1": "Du vet hva som er innafor. Likevel er det noe som plager deg.",
      "ingress2": "Mange får det lettere etter å ha delt tankene sine med en de stoler på. Det at du har tatt denne testen er et godt steg i riktig retning for å få det bedre.\n\nDet vil være bra å snakke med noen.",
      "resources": [
        {
          "title": "Hva er samtykke til sex?",
          "text": "Å gi samtykke betyr å si ja, enten med ord eller med kroppsspråk. Du kan få samtykke til å kose, kysse, ta på, fingre, runke, ha sex eller andre ting.",
          "navigateTo": "https://www.ung.no/overgrep/3251_Hva_er_samtykke_til_sex.html"
        },
        {
          "title": "Kan jeg ha sex før jeg fyller 16 år?",
          "text": "Mange lurer på om det er ulovlig å ha sex hvis de selv, eller den de vil ha sex med, er under seksuell lavalder. Her forklarer vi regelverket for sex mellom ungdom.",
          "navigateTo": "https://www.ung.no/Sex/2422_Hva_er_seksuell_lavalder.html"
        }
      ],
      "toolIds": ["a68c3e61-a1cc-4a62-aff5-59b674559948", "a68c3e61-a1cc-4a62-aff5-59b674559948"],
      "exit": [
        {
          "exitTitle": "Vil du lære mer?",
          "exitIngress": "Hvis du vil utforske et eller flere av temaene våre, kan du \ntrykke på knappen under for å komme til temaoversikten."
        }
      ],
      "navigationButtons": [
        { "text": "Et steg tilbake", "type": 2, "navigateTo": null },
        { "text": "LÆR MER", "type": 4, "navigateTo": "/temavalg" }
      ]
    }
  ],
  "externalLinks": [
    {
      "linkName": "externalQuestionnaire",
      "linkValues": {
        "linkText": "Gi tilbakemelding!",
        "webLink": "https://forms.office.com/pages/responsepage.aspx?id=XL2haw911kqrow-VWFvCH3Ke1-mVzEtAhvsitkgDoRhUQVAwUEJFS1dZN0MwQzNNQllKVEhWRlQ3UC4u",
        "mobileLink": "https://forms.office.com/pages/responsepage.aspx?id=XL2haw911kqrow-VWFvCH3Ke1-mVzEtAhvsitkgDoRhUQVAwUEJFS1dZN0MwQzNNQllKVEhWRlQ3UC4u"
      }
    },
    {
      "linkName": "externalTilgjengelighetserklaering",
      "linkValues": {
        "linkText": "Tilgjengelighetserklæring",
        "webLink": "https://uustatus.no/nb/erklaringer/publisert/c4e65bd6-53a5-4400-9bf9-1821b0524c58",
        "mobileLink": "https://uustatus.no/nb/erklaringer/publisert/c4e65bd6-53a5-4400-9bf9-1821b0524c58"
      }
    }
  ],
  "keywords": [
    { "keyword": "samtykke", "info": "å si seg enig eller å gi tillatelse" },
    {
      "keyword": "grenser",
      "info": "Dine personlige grenser inkluderer graden av fysisk kontakt du aksepterer i sosiale situasjoner"
    },
    {
      "keyword": "grense",
      "info": "Dine personlige grenser inkluderer graden av fysisk kontakt du aksepterer i sosiale situasjoner"
    }
  ],
  "languages": [
    {
      "language": "Bokmål",
      "cultureName": "no",
      "resolvedUrl": "https://www.helsenorge.no/sex-og-samliv/hvaerinnafor/",
      "isCurrentLanguage": true
    },
    {
      "language": "Nynorsk",
      "cultureName": "nn",
      "resolvedUrl": "https://www.helsenorge.no/nn/sex-og-samliv/kva-er-innafor/",
      "isCurrentLanguage": false
    }
  ]
}
